/* global globalThis */
import {checkIfW42CelectialsCavalryPlayer} from "../factions/celectialsBot";
import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectCurrentPlayer,
  selectFinalRound,
  selectGameType,
  selectHexes,
  selectNextInitiativePlayerId,
  selectPendingRecruitmentActions,
  selectPhase,
  selectPhaseCompletedPlayers,
  selectPlayers,
  selectRound,
  selectSharedGameState,
  selectSpecialBuildings,
  selectTurnOrder,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {addPendingRecruitmentAction, recruitUnit, upgradeUnit} from "../../../redux/actions";
import {UNIT_UPGRADES} from "../../../configs/unitUpgrade";
import {calculateAvailableRecruitmentCells} from "../../gameState/calculateAvailableRecruitmentCells";
import {
  checkSameTypeUnitRecruitmentLimit,
  getSameTypeUnitLimit,
} from "../../gameState/recruitment/checkSameTypeUnitRecruitmentLimit";
import {checkIfUnitTypeChangeExceedsLimit} from "../../gameState/recruitment/checkIfUnitTypeChangeExceedsLimit";
import {calcCoinsRecruitmentSize} from "../../gameState/recruitment/calcCoinsRecruitmentSize";
import {getSizeRecruitmentPrice} from "../../recruitment/getSizeRecruitmentPrice";
import {getPlayerUnits} from "../../players/getPlayerUnits";
import {checkIfFinalRound, getRoundLimit} from "../../checkIfFinalRound";
import {checkIfHexBlockedByEnemyUnit} from "../../gameState/checkIfHexBlockedByEnemyUnit";
import {getAllQuartersOfCity} from "../../gameState/getAllQuartersOfCity";
import {getUnitPrice, getUnitTypeConfig, UNIT_TYPES, UNITS_SAME_TIME_COUNT_LIMIT} from "../../../configs/units";
import {getBotHireArmyCap} from "../getBotArmyCap";
import {
  isPreRecruitmentCapFixPlayer,
  isPreW32ArmyUpgradePlayer,
  isPreW32DefensePlayer,
  isPreW35LateHirePlayer,
} from "../abTestGates";
import {
  CITY_THREAT_LEVELS,
  getCityCaptureThreats,
  getGuardNeededCityBarracks,
  getLaterWarMoverIds,
} from "../evaluation/cityCaptureThreat";
import {
  checkIfW32UpgradeYieldsToDefender,
  getW32ArmyConfig,
  pickW32UnitUpgrade,
} from "../evaluation/armyGrowth";
import {getAvailableUnitUpgrades} from "../../unit/getAvailableUnitUpgrades";
import {COMMON_BUILDING_TOKENS, SPECIAL_BUILDING_TOKENS, TOKENS} from "../../../constants/tokens";
import {createRandomId} from "../../ids/createRandomId";
import {ID_PREFIX_FOR_UNIT} from "../../../constants/ids";
import {getBotStrategy} from "../strategy/botStrategyStore";
import {BOT_ARCHETYPES} from "../strategy/archetypes";
import {getBotProfile} from "../strategy/getBotProfile";
import {getBotBonusProfile} from "../getBotBonusProfile";
import {classifyOwnCity, getBonusAxis} from "../strategy/bonusAxis";
import {isBonusArmyPhase} from "../../../configs/botBonusBehavior";
import {
  calcFarmsSupplyCapacity,
  collectArsenalCityBarracks,
  collectCampAdjacentBarracks,
  collectForgeBarracks,
  collectThreatenedUndefendedFrontierBarracks,
  getStrongCitiesBarracksRank,
  sortBarracksForStrongCities,
} from "../evaluation/bonusRecruitment";
import {
  calcW37RichExtraSlots,
  checkIfW37CoinsArePoints,
  checkIfW37D20CampHireAllowed,
  checkIfW37RichTypesApply,
  collectW37FrontierUncoveredCityKeys,
  collectW37ThreatGuardNeeds,
  collectW37WeakGuardIds,
  getW37HireFeatures,
  pickW37GuardType,
  sortW37CampArsenalBarracks,
  sortW37FrontierHireCells,
  sortW37RichTypePreference,
} from "../evaluation/w37Recruitment";
import {getW37FrontierCityKeys, getW37ThisRoundCityThreats} from "../evaluation/w37Threat";
import {getW37RecruitmentKnobs} from "../../../configs/botW37Recruitment";

import {NEUTRAL_PLAYER_COLOR, NEUTRAL_PLAYER_ID} from "../../../constants/players";
import {keyToCoords} from "../../coords/keyToCoords";
import {BOT_COIN_DEEP_SURPLUS, BOT_COIN_SURPLUS_THRESHOLD, RATMEN_CAVALRY_ROUND} from "../botConfig";
import {FINAL_ROUND} from "../../../configs/game";
import {getCachedRoundPlan, getPlannerMode} from "../planner/plannerStore";
import {ensureRoundPlan} from "../planner/selectPlanByRollout";
import {calcPlayerArmyStrength, findOwnCitiesUnderThreat} from "../evaluation/armyStrength";
import {
  calcBfsDistances, calcSupplyReachCells, calcSupplyReachCellsWithRelay, getBotGridRenderer,
} from "../botGrid";

import {getEnemyQuarterHexKeys} from "../evaluation/cities";
import {getPlayerFarms} from "../../gameState/getPlayerFarms";
import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";
import {isPlayerFaction} from "../../factions/isPlayerFaction";
import {getRecruitableUnitTypeIds} from "../../unit/getRecruitableUnitTypeIds";
import {FACTIONS} from "../../../constants/factions";
import {ADDITIONAL_SUPPLY_SPEED} from "../../../configs/supply";
import {
  checkIfW35GarrisonPlayer,
  GARRISON_EXPOSURE,
  getGarrisonDoctrine,
  selectGarrisonAssignments,
} from "../evaluation/garrisons";
import {GARRISON_DOCTRINES} from "../../../configs/botGarrison";
import {
  calcLateHireRemainingMoves,
  calcLateSizeHireRound,
  calcW35HolderSizePurchases,
  checkIfLateHireTargetInReach,
  checkIfLateHireWindow,
  W35_HOLDER_HIRE_COIN_MARGIN,
  W35_LATE_HIRE_CONTACT_EXTRA_CELLS,
} from "../../../configs/botLateHire";
import {checkIfCityHasWorkingArsenal} from "../../gameState/recruitment/checkIfCityHasWorkingArsenal";
import {
  RECRUITMENT_SIZE_WITH_COINS_DEFAULT,
  RECRUITMENT_SIZE_WITH_COINS_WITH_ARSENAL,
} from "../../../configs/recruitment";
import {checkIfW39GiantsHireAllowed, checkIfW39GiantsPlayer, getW39GrowthMaxSize} from "../factions/giantsBot";
import {calcW39SeductionCoinReserve} from "../factions/succubesBot";

// С какого раунда найм размера за монеты разрешен всем архетипам
const SIZE_HIRE_LATE_GAME_ROUND = 10;

// Волна 22 (21.1): до какого раунда включительно найм при простаивающей
// мощности (свободная рабочая казарма + ферма под отряд + монеты) обгоняет
// накопления на строительные цели
const IDLE_CAPACITY_HIRE_MAX_ROUND = 10;

// Объединение relay-досягаемости всех своих ферм (волна 33)
const calcSupplyReachCellsUnionWithRelay = (farmHexKeys, hexes, gridRenderer) => {
  const farmSet = new Set(farmHexKeys);
  const union = new Set();
  farmHexKeys.forEach((farmHexKey) => {
    calcSupplyReachCellsWithRelay(farmHexKey, farmSet, hexes, gridRenderer).forEach((cellKey) => union.add(cellKey));
  });
  return union;
};

// Волна 31: слоты сверх базового потолка отрядов (UNITS_SAME_TIME_COUNT_LIMIT —
// это лимит правил на отряды ОДНОГО типа, бот же держит его как общий).
// Инсектоиды не зависят от снабжения, их сила в массе — им потолок поднимается
// целиком; BARBARISM получает слоты только под НЕ-d6 (бесплатный рой d6 иначе
// занимает весь потолок и блокирует найм более сильных типов)
const INSECTOIDS_EXTRA_UNIT_SLOTS = 3;
const BARBARISM_NON_D6_EXTRA_SLOTS = 2;

// Симуляции калибруют размер прибавки, не меняя код (в проде оверрайд не задан)
const getInsectoidsExtraUnitSlots = () => (
  typeof globalThis.__insectoidsExtraUnitSlots === 'number'
    ? globalThis.__insectoidsExtraUnitSlots
    : INSECTOIDS_EXTRA_UNIT_SLOTS
);
const getBarbarismNonD6ExtraSlots = () => (
  typeof globalThis.__barbarismNonD6ExtraSlots === 'number'
    ? globalThis.__barbarismNonD6ExtraSlots
    : BARBARISM_NON_D6_EXTRA_SLOTS
);

// Волна 33 («сильные города», configs/botBonusBehavior): единая точка гейта
// пакета strongCities для этапа найма. У обычных ботов, BIG и legacy-группы
// A/B профиль дает strongCities=false — тогда strongCities/axis/isArmyPhase
// ложны, и весь этап выполняется прежним кодом дословно.
//  - axis — ось удара текущего раунда (кузница, тыл, ближайший живой
//    противник), посчитана в executeBotStep; null — правила оси не действуют;
//  - isArmyPhase — первые 2/3 матча: монеты идут в армию, резерв под
//    строительную цель найм не держит (H3)
const getStrongCitiesHireContext = (state, currentPlayer) => {
  const bonusProfile = getBotBonusProfile(currentPlayer, selectGameType(state));
  const strongCities = Boolean(bonusProfile?.strongCities);
  return {
    bonusProfile,
    strongCities,
    axis: strongCities ? getBonusAxis(currentPlayer.id) : null,
    isArmyPhase: strongCities && isBonusArmyPhase(selectRound(state)),
  };
};

// Гексагональная дистанция по осевым координатам (проверки досягаемости)
const calcHexDistanceLocal = (cellKeyA, cellKeyB) => {
  const [aq, ar] = keyToCoords(cellKeyA);
  const [bq, br] = keyToCoords(cellKeyB);
  return (Math.abs(aq - bq) + Math.abs(ar - br) + Math.abs((aq + ar) - (bq + br))) / 2;
};

// ---- Волна 35: найм в конце партии (R) и под гарнизоны (G-найм), configs/botLateHire ----

// Кэш BFS-дистанций до целей позднего найма — на фазу: чужие отряды в фазе бота
// не ходят, города на этапе найма не меняются, а этап идет по действию за тик.
// Ключ: игрок, раунд, фаза и чужие отряды; плюс ссылки на клетки поля, кэш
// городов и сетку
let w35TargetDistancesMemo = null;

// BFS-дистанции до чужих отрядов и до кварталов чужих городов (нейтральные —
// тоже цели: их гарнизоны бьются, а города захватываются)
const getW35TargetDistances = (state, currentPlayer) => {
  const units = selectUnits(state) || [];
  const hexes = selectHexes(state);
  const citiesCache = selectCitiesCache(state);
  const gridRenderer = getBotGridRenderer(state);
  const otherUnits = units.filter((unit) => unit.ownerId !== currentPlayer.id);
  const key = [
    currentPlayer.id, currentPlayer.color, selectRound(state), selectPhase(state),
    otherUnits.map((unit) => `${unit.id}@${unit.hexKey}`).join('|'),
  ].join('#');
  const memo = w35TargetDistancesMemo;
  if (memo && memo.key === key && memo.hexes === hexes && memo.citiesCache === citiesCache
    && memo.gridRenderer === gridRenderer) {
    return memo.result;
  }
  const enemyQuarterKeys = [...getEnemyQuarterHexKeys(citiesCache, currentPlayer.color).keys()];
  const result = {
    unitDistances: otherUnits.length > 0
      ? calcBfsDistances(otherUnits.map((unit) => unit.hexKey), hexes, gridRenderer)
      : new Map(),
    quarterDistances: enemyQuarterKeys.length > 0
      ? calcBfsDistances(enemyQuarterKeys, hexes, gridRenderer)
      : new Map(),
  };
  w35TargetDistancesMemo = {key, hexes, citiesCache, gridRenderer, result};
  return result;
};

const intersectUnitFilters = (filterA, filterB) => {
  if (!filterA) {
    return filterB;
  }
  if (!filterB) {
    return filterA;
  }
  return new Set([...filterA].filter((unitId) => filterB.has(unitId)));
};

/**
 * Контекст найма волны 35 на один вызов этапа: состояние в нем не меняется до
 * первого dispatch, после которого этап возвращает true. Производные считаются
 * лениво и один раз. null — у игрока нет ни R, ни G-найма (legacy или G только у
 * бонуса «большой» и выше): этап идет прежним кодом дословно.
 *  isLateHire — R: найм в конце партии с горизонтом (гейт isPreW35LateHirePlayer);
 *  isGarrisonHire — G-найм: размер слабым держателям гарнизонов и заслон
 *    открытого города экономической доктрины (checkIfW35GarrisonPlayer: бонус
 *    «большой» и выше, гейт isPreW35GarrisonPlayer)
 */
const createW35HireContext = (state, currentPlayer) => {
  const isLateHire = !isPreW35LateHirePlayer(currentPlayer.id);
  const isGarrisonHire = checkIfW35GarrisonPlayer(currentPlayer, selectGameType(state));
  if (!isLateHire && !isGarrisonHire) {
    return null;
  }
  const round = selectRound(state);
  const roundLimit = getRoundLimit(selectFinalRound(state));
  const isFinalWindow = isLateHire && checkIfLateHireWindow(round, roundLimit);
  const remainingMoves = calcLateHireRemainingMoves(round, roundLimit);
  // Монета у Просветленных — очко (курс 1:1), FANATICISM меняет очки на монеты:
  // им в конце партии — только заслоны и держатели угрожаемых городов
  const isStrict = isPlayerFaction(currentPlayer, FACTIONS.ENLIGHTENED)
    || isPlayerPolicy(currentPlayer, POLICIES.FANATICISM);
  const hexes = selectHexes(state);
  const units = selectUnits(state) || [];
  const citiesCache = selectCitiesCache(state);
  const playerCities = citiesCache?.[currentPlayer.color] || [];

  let assignments = null;
  const getAssignments = () => {
    if (assignments === null) {
      assignments = selectGarrisonAssignments(state, currentPlayer.id);
    }
    return assignments;
  };

  // Запись гарнизона города по клетке его казармы
  let entryByBarracks = null;
  const getEntryByBarracks = () => {
    if (entryByBarracks === null) {
      entryByBarracks = new Map();
      const cityByKey = new Map(playerCities.map((city) => [city.centralQuarter, city]));
      getAssignments().forEach((entry) => {
        (cityByKey.get(entry.cityKey)?.[COMMON_BUILDING_TOKENS.BARRACKS] || [])
          .forEach((cellKey) => entryByBarracks.set(cellKey, entry));
      });
    }
    return entryByBarracks;
  };

  // Доктрина с поправкой на бонус — та же, что требует гарнизоны (garrisons.js)
  const isEconomicDoctrine = isGarrisonHire
    && getGarrisonDoctrine(currentPlayer, selectGameType(state)) === GARRISON_DOCTRINES.ECONOMIC;

  // G-найм, держатель из накоплений: обязательные города под угрозой «скоро» и
  // выше без держателя, до свободного квартала которых этим ходом не дойдет ни
  // один свой отряд (reachable === false — в том числе у города сверх капа
  // гарнизонов). Запись: {entry, city, barracks — казармы города, смежные
  // свободному кварталу, ownOnBarracks — свои отряды на них (держать город они не
  // могут: обречены в своем бою, голодают или держат другой город)}
  let holderNeeds = null;
  const getHolderNeeds = () => {
    if (holderNeeds === null) {
      holderNeeds = [];
      if (!isGarrisonHire || playerCities.length === 0) {
        return holderNeeds;
      }
      const cityByKey = new Map(playerCities.map((city) => [city.centralQuarter, city]));
      const occupiedCells = new Set(units.map((unit) => unit.hexKey));
      const ownUnitByCell = new Map(units
        .filter((unit) => unit.ownerId === currentPlayer.id)
        .map((unit) => [unit.hexKey, unit]));
      getAssignments().forEach((entry) => {
        const isThreatened = entry.threatLevel > CITY_THREAT_LEVELS.NONE || entry.isSoon === true;
        if (!entry.required || entry.exposure !== GARRISON_EXPOSURE.OPEN || !isThreatened || entry.unitId
          || entry.reachable !== false || entry.holderIds.length > 0
        ) {
          return;
        }
        const city = cityByKey.get(entry.cityKey);
        const freeQuarters = entry.quarters.filter((quarterKey) => !occupiedCells.has(quarterKey));
        const barracks = (city?.[COMMON_BUILDING_TOKENS.BARRACKS] || []).filter((cellKey) => freeQuarters
          .some((quarterKey) => calcHexDistanceLocal(quarterKey, cellKey) === 1));
        if (barracks.length > 0) {
          holderNeeds.push({
            entry,
            city,
            barracks,
            ownOnBarracks: barracks.map((cellKey) => ownUnitByCell.get(cellKey)).filter(Boolean),
          });
        }
      });
    }
    return holderNeeds;
  };

  // G-найм: казармы открытых городов экономической доктрины без гарнизона
  // (Map казарма -> город под угрозой «скоро» и выше) и слабые держатели
  // гарнизонов на казармах — размер меньше ожидаемого урона ближайшего врага,
  // но максимум типа его переживает (иначе монеты уйдут в обреченный отряд).
  // Держатель из накоплений: свой отряд на казарме обязательного города без
  // держателя, который пока город не удержит, — тоже слабый держатель
  let garrisonNeeds = null;
  const getGarrisonNeeds = () => {
    if (garrisonNeeds === null) {
      garrisonNeeds = {guardBarracks: new Map(), weakHolderIds: new Set(), threatenedWeakHolderIds: new Set()};
      if (!isGarrisonHire || playerCities.length === 0) {
        return garrisonNeeds;
      }
      const cityByKey = new Map(playerCities.map((city) => [city.centralQuarter, city]));
      const unitById = new Map(units.map((unit) => [unit.id, unit]));
      const ownUnitCells = new Set(units
        .filter((unit) => unit.ownerId === currentPlayer.id)
        .map((unit) => unit.hexKey));
      const assignedIds = new Set(getAssignments().map((entry) => entry.unitId).filter(Boolean));
      getHolderNeeds().forEach(({entry, ownOnBarracks}) => {
        ownOnBarracks.forEach((unit) => {
          const unitMaxSize = unit.maxSize || getUnitTypeConfig(unit.type)?.maxSize || 0;
          if (!assignedIds.has(unit.id) && unit.size <= entry.expectedDamage && unitMaxSize > entry.expectedDamage) {
            garrisonNeeds.weakHolderIds.add(unit.id);
            garrisonNeeds.threatenedWeakHolderIds.add(unit.id);
          }
        });
      });
      getAssignments().forEach((entry) => {
        if (!entry.required || entry.exposure !== GARRISON_EXPOSURE.OPEN) {
          return;
        }
        const isThreatened = entry.threatLevel > CITY_THREAT_LEVELS.NONE || entry.isSoon === true;
        if (!entry.unitId) {
          const cityBarracks = cityByKey.get(entry.cityKey)?.[COMMON_BUILDING_TOKENS.BARRACKS] || [];
          // Свой отряд на казарме города встанет на квартал перемещением — заслон не нужен
          if (isEconomicDoctrine && !cityBarracks.some((cellKey) => ownUnitCells.has(cellKey))) {
            cityBarracks.forEach((cellKey) => garrisonNeeds.guardBarracks.set(
              cellKey, isThreatened || garrisonNeeds.guardBarracks.get(cellKey) === true
            ));
          }
          return;
        }
        const holder = unitById.get(entry.unitId);
        if (!holder || hexes[holder.hexKey] !== COMMON_BUILDING_TOKENS.BARRACKS) {
          return;
        }
        const holderMaxSize = holder.maxSize || getUnitTypeConfig(holder.type)?.maxSize || 0;
        if (holder.size <= entry.expectedDamage && holderMaxSize > entry.expectedDamage) {
          garrisonNeeds.weakHolderIds.add(holder.id);
          if (isThreatened) {
            garrisonNeeds.threatenedWeakHolderIds.add(holder.id);
          }
        }
      });
    }
    return garrisonNeeds;
  };

  // R: казармы городов под угрозой — заслоны волн 19/32 (враг в радиусе 2 и
  // риск захвата по досягаемости без живучего держателя)
  let threatenedBarracks = null;
  const getThreatenedBarracks = () => {
    if (threatenedBarracks === null) {
      threatenedBarracks = new Set();
      findOwnCitiesUnderThreat(currentPlayer, units, citiesCache, getBotGridRenderer(state))
        .forEach(({city}) => (city[COMMON_BUILDING_TOKENS.BARRACKS] || [])
          .forEach((cellKey) => threatenedBarracks.add(cellKey)));
      if (!isPreW32DefensePlayer(currentPlayer.id)) {
        getGuardNeededCityBarracks(getCityCaptureThreats(state, currentPlayer).cityThreats, CITY_THREAT_LEVELS.NEXT_ROUND)
          .forEach((level, cellKey) => threatenedBarracks.add(cellKey));
      }
    }
    return threatenedBarracks;
  };

  const checkTargetInReach = (cellKey, speed, extraCells = 0) => {
    const {unitDistances, quarterDistances} = getW35TargetDistances(state, currentPlayer);
    return checkIfLateHireTargetInReach({
      unitDistance: unitDistances.get(cellKey),
      quarterDistance: quarterDistances.get(cellKey),
      speed,
      remainingMoves,
      extraCells,
    });
  };

  // R+G: назначенные гарнизоны (G-найм) городов под угрозой «скоро» и выше и
  // (кроме Просветленных и FANATICISM) открытых городов. Гарнизон может стоять на
  // казарме ДРУГОГО города (дойдет до кварталов своего этим ходом) — по городу
  // казармы его держание не видно
  let assignedHolderIds = null;
  const getAssignedHolderIds = () => {
    if (assignedHolderIds === null) {
      assignedHolderIds = new Set();
      if (isGarrisonHire) {
        getAssignments().forEach((entry) => {
          const isThreatened = entry.threatLevel > CITY_THREAT_LEVELS.NONE || entry.isSoon === true;
          if (entry.unitId && (isThreatened || (!isStrict && entry.exposure === GARRISON_EXPOSURE.OPEN))) {
            assignedHolderIds.add(entry.unitId);
          }
        });
      }
    }
    return assignedHolderIds;
  };

  /**
   * R: отряды на казармах, которым в конце партии докупается размер: заслоны и
   * держатели угрожаемых городов; кроме Просветленных и FANATICISM — еще
   * держатели открытых городов, отряды в контакте (враг встанет рядом за одно
   * свое перемещение) и под цель, до которой отряд успеет дойти. Держатель —
   * и отряд на казарме своего города, и назначенный гарнизон (G) на любой
   * казарме (getAssignedHolderIds), поэтому слабые держатели G-найма
   * (getWeakHolderIds — гарнизоны открытых городов) входят в набор целиком, а у
   * Просветленных и FANATICISM — держатели угрожаемых городов: фильтр окна конца
   * партии их не отрезает
   */
  let lateSizeUnitIds = null;
  const getLateSizeUnitIds = (playerUnits) => {
    if (lateSizeUnitIds !== null) {
      return lateSizeUnitIds;
    }
    lateSizeUnitIds = new Set();
    const liveEnemyUnits = units.filter((unit) => unit.ownerId !== currentPlayer.id
      && unit.ownerId !== NEUTRAL_PLAYER_ID);
    playerUnits.forEach((unit) => {
      if (hexes[unit.hexKey] !== COMMON_BUILDING_TOKENS.BARRACKS) {
        return;
      }
      const entry = getEntryByBarracks().get(unit.hexKey);
      if (getThreatenedBarracks().has(unit.hexKey)
        || (entry && (entry.threatLevel > CITY_THREAT_LEVELS.NONE || entry.isSoon === true))
        || getAssignedHolderIds().has(unit.id)
      ) {
        lateSizeUnitIds.add(unit.id);
        return;
      }
      if (isStrict) {
        return;
      }
      if ((entry && entry.exposure === GARRISON_EXPOSURE.OPEN)
        || liveEnemyUnits.some((enemy) => calcHexDistanceLocal(enemy.hexKey, unit.hexKey)
          <= (getUnitTypeConfig(enemy.type)?.speed || 2) + W35_LATE_HIRE_CONTACT_EXTRA_CELLS)
        || checkTargetInReach(
          unit.hexKey,
          getUnitTypeConfig(unit.type)?.speed || 2,
          unit.additionalSupply === true ? ADDITIONAL_SUPPLY_SPEED : 0
        )
      ) {
        lateSizeUnitIds.add(unit.id);
      }
    });
    return lateSizeUnitIds;
  };

  return {
    isLateHire,
    isGarrisonHire,
    isFinalWindow,
    isStrict,
    remainingMoves,
    // R: с какого раунда найм размера открыт всем архетипам (под цель или угрозу)
    sizeHireOpenRound: calcLateSizeHireRound(roundLimit, SIZE_HIRE_LATE_GAME_ROUND),
    roundLimit,
    getLateSizeUnitIds,
    getWeakHolderIds: () => getGarrisonNeeds().weakHolderIds,
    // G-найм: обязательные города без держателя, до которых не дойдет ни один свой отряд
    getHolderNeeds,
    // Слабые держатели городов под угрозой «скоро» и выше: накопления на стройку их размер не блокируют
    getSavingsBypassHolderIds: () => getGarrisonNeeds().threatenedWeakHolderIds,
    /**
     * Казармы заслонов волны 32 плюс заслоны G-найма (уровень NEXT_ROUND). В окне
     * конца партии (R) — только города под угрозой «скоро» и выше: открытый, но
     * не угрожаемый город до конца партии взять не успеют. Без новых казарм —
     * тот же объект, что передан (legacy-порядок дословно)
     */
    mergeGuardLevels: (w32GuardLevels) => {
      // Заслоны G — только экономической доктрине: остальным назначение не считается
      if (!isEconomicDoctrine) {
        return w32GuardLevels;
      }
      let merged = w32GuardLevels;
      getGarrisonNeeds().guardBarracks.forEach((isThreatened, cellKey) => {
        if ((isFinalWindow && !isThreatened) || (merged && merged.has(cellKey))) {
          return;
        }
        if (merged === w32GuardLevels) {
          merged = new Map(w32GuardLevels || []);
        }
        merged.set(cellKey, CITY_THREAT_LEVELS.NEXT_ROUND);
      });
      return merged;
    },
    /**
     * R, окно конца партии: казарма годится под новый отряд типа unitTypeId —
     * заслон угрожаемого города (в том числе угрозы «скоро», как у размера в
     * getLateSizeUnitIds, если на кварталах нет своего отряда, а у G — и
     * назначенного гарнизона) или (кроме Просветленных и FANATICISM) цель в
     * досягаемости: скорость типа × оставшиеся перемещения
     */
    checkNewUnitCell: (cellKey, unitTypeId, guardLevels) => {
      if ((guardLevels && guardLevels.has(cellKey)) || getThreatenedBarracks().has(cellKey)) {
        return true;
      }
      const entry = getEntryByBarracks().get(cellKey);
      if (entry && entry.isSoon === true && entry.holderIds.length === 0 && !(isGarrisonHire && entry.unitId)) {
        return true;
      }
      if (isStrict) {
        return false;
      }
      return checkTargetInReach(cellKey, getUnitTypeConfig(unitTypeId)?.speed || 2);
    },
  };
};

// ---- Волна 37: найм на оборону своих городов у ботов «золото+» (T, F, E, A;
// правила — evaluation/w37Recruitment, ручки — configs/botW37Recruitment) ----

// Журнал найма волны 37 для харнесса и стендов (в проде globalThis.__w37HireLog
// не задан): заслоны T, наймы на слоты F, размер свежему найму A. Песочницы
// прогнозов и роллаутов (store.__isBotSandbox) в журнал не пишут
const recordW37Hire = (store, record) => {
  if (!store.__isBotSandbox && Array.isArray(globalThis.__w37HireLog)) {
    globalThis.__w37HireLog.push(record);
  }
};

/**
 * Контекст найма волны 37 на один вызов этапа (как у волны 35: состояние в нем
 * не меняется до первого dispatch, после которого этап возвращает true).
 * Производные считаются лениво и один раз. null — у игрока нет ни одной
 * подчасти (не золото+ или все четыре в legacy-наборах A/B): этап идет прежним
 * кодом дословно. Поля isThreatHire, isFrontierHire, isRichUnits,
 * isCampArsenalHire — действует ли подчасть (getW37HireFeatures)
 */
const createW37HireContext = (state, currentPlayer, playerUnits) => {
  const features = getW37HireFeatures(currentPlayer, selectGameType(state));
  if (!features) {
    return null;
  }
  const knobs = getW37RecruitmentKnobs();
  const round = selectRound(state);
  const roundLimit = getRoundLimit(selectFinalRound(state));
  const units = selectUnits(state) || [];
  const hexes = selectHexes(state);
  const citiesCache = selectCitiesCache(state);
  const playerCities = citiesCache?.[currentPlayer.color] || [];
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const pendingRecruitmentActions = selectPendingRecruitmentActions(state) || [];
  const isCoinsArePoints = checkIfW37CoinsArePoints(currentPlayer);

  // T, F: угроза своим городам в этом раунде — отряды и фантомный найм ходящих
  // после бота (getW37ThisRoundCityThreats: кэш на состояние, внутри — на
  // позицию). Фантомы противника-бота — только при запасе от
  // W37_THREAT_BOT_RECRUIT_MIN_COINS. «Скоро» здесь не считается: его порядку F
  // дает назначение гарнизонов волны 35 (тот же кэш, что у G-найма)
  let threats = null;
  const getThreats = () => {
    if (threats === null) {
      threats = getW37ThisRoundCityThreats(state, currentPlayer, {
        humanRecruitsOnly: currentPlayer.coins < knobs.threatBotRecruitMinCoins,
      });
    }
    return threats;
  };

  // T: города, которым нужен заслон в этом раунде (collectW37ThreatGuardNeeds).
  // Ходящих после бота нет — нет ни угрозы отрядами, ни фантомов: без расчета
  let threatGuardNeeds = null;
  const getThreatGuardNeeds = () => {
    if (threatGuardNeeds === null) {
      threatGuardNeeds = [];
      if (features.isThreatHire && playerCities.length > 0) {
        const players = selectPlayers(state) || [];
        const turnOrder = selectTurnOrder(state) || [];
        const laterMoverIds = getLaterWarMoverIds({
          phase: selectPhase(state),
          turnOrder: turnOrder.length > 0 ? turnOrder : players.map((player) => player.id),
          nextInitiativePlayerId: selectNextInitiativePlayerId(state),
          phaseCompletedPlayers: selectPhaseCompletedPlayers(state),
          currentPlayerId: currentPlayer.id,
        });
        // Враг уже на квартале — угроза этого раунда и без ходящих после бота
        const hasEnemyOnOwnQuarter = laterMoverIds.size === 0 && units.some((unit) => unit.ownerId !== currentPlayer.id
          && unit.ownerId !== NEUTRAL_PLAYER_ID
          && playerCities.some((city) => getAllQuartersOfCity(city).includes(unit.hexKey)));
        if (laterMoverIds.size > 0 || hasEnemyOnOwnQuarter) {
          threatGuardNeeds = collectW37ThreatGuardNeeds({
            cityThreats: getThreats().cityThreats, units, currentPlayerId: currentPlayer.id, laterMoverIds,
          });
        }
      }
    }
    return threatGuardNeeds;
  };

  // F: монеты сверх накоплений на стройку (в армейской фазе «сильных городов»
  // накопления найм не держит) и фронтирные города без своего отряда рядом
  const strongCitiesHire = getStrongCitiesHireContext(state, currentPlayer);
  const savingsReserve = strongCitiesHire.isArmyPhase ? 0 : getBotStrategy(currentPlayer.id).savingsGoal?.price || 0;
  let frontierUncoveredCityKeys = null;
  const getFrontierUncoveredCityKeys = () => {
    if (frontierUncoveredCityKeys === null) {
      frontierUncoveredCityKeys = features.isFrontierHire && !isCoinsArePoints && playerCities.length > 0
        ? collectW37FrontierUncoveredCityKeys({
          playerCities,
          frontierCityKeys: getW37FrontierCityKeys(state, currentPlayer),
          units,
          currentPlayerId: currentPlayer.id,
        })
        : new Set();
    }
    return frontierUncoveredCityKeys;
  };
  // Слоты F: запас монет — первым (дешево), фронтир — только при запасе; слоты —
  // только когда у фронтирного города без своего отряда есть свободная рабочая
  // казарма. Ниже общего потолка армии слоты не нужны — их не считают
  let frontierExtraSlots = null;
  const getFrontierExtraSlots = () => {
    if (frontierExtraSlots === null) {
      frontierExtraSlots = 0;
      const slots = features.isFrontierHire && !isCoinsArePoints && playerUnits.length >= getBotHireArmyCap(currentPlayer)
        ? calcW37RichExtraSlots(currentPlayer.coins - savingsReserve, knobs)
        : 0;
      const cityKeys = slots > 0 ? getFrontierUncoveredCityKeys() : null;
      if (cityKeys && cityKeys.size > 0) {
        const recruitmentCells = new Set(calculateAvailableRecruitmentCells(state));
        if (playerCities.some((city) => cityKeys.has(city.centralQuarter)
          && (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).some((cellKey) => recruitmentCells.has(cellKey)))
        ) {
          frontierExtraSlots = slots;
        }
      }
    }
    return frontierExtraSlots;
  };
  // Города под угрозой «скоро» — по назначению гарнизонов волны 35 (кэш на позицию)
  const getSoonCityKeys = () => new Set(selectGarrisonAssignments(state, currentPlayer.id)
    .filter((entry) => entry.isSoon === true)
    .map((entry) => entry.cityKey));
  // Живые противники: их отряды и кварталы — источники близости для порядка F
  let enemySourceKeys = null;
  const getEnemySourceKeys = () => {
    if (enemySourceKeys === null) {
      enemySourceKeys = units
        .filter((unit) => unit.ownerId !== currentPlayer.id && unit.ownerId !== NEUTRAL_PLAYER_ID)
        .map((unit) => unit.hexKey);
      getEnemyQuarterHexKeys(citiesCache, currentPlayer.color).forEach((cityInfo, quarterHexKey) => {
        if (cityInfo.color !== NEUTRAL_PLAYER_COLOR) {
          enemySourceKeys.push(quarterHexKey);
        }
      });
    }
    return enemySourceKeys;
  };

  // A: казармы у рабочего лагеря и казармы городов с рабочим арсеналом
  let campBarracks = null;
  const getCampBarracks = () => {
    if (campBarracks === null) {
      campBarracks = collectCampAdjacentBarracks({
        playerCities, currentPlayer, units, hexes, specialBuildings, citiesCache, buildingsDamage,
      });
    }
    return campBarracks;
  };
  let arsenalBarracks = null;
  const getArsenalBarracks = () => {
    if (arsenalBarracks === null) {
      arsenalBarracks = collectArsenalCityBarracks({
        playerCities, currentPlayerId: currentPlayer.id, units, hexes, specialBuildings, buildingsDamage,
      });
    }
    return arsenalBarracks;
  };
  // Отряды, нанятые в этой фазе (заявка найма в pendingRecruitmentActions)
  let freshUnitIds = null;
  const getFreshUnitIds = () => {
    if (freshUnitIds === null) {
      freshUnitIds = new Set(pendingRecruitmentActions
        .filter((action) => action.actionType === 'UNIT_RECRUITMENT')
        .map((action) => action.unitId));
    }
    return freshUnitIds;
  };

  return {
    ...features,
    knobs,
    getThreatGuardNeeds,
    // T: свои отряды на казармах угрожаемых городов, которым пока не хватает размера
    getWeakGuardIds: () => collectW37WeakGuardIds({
      needs: getThreatGuardNeeds(), ownUnits: playerUnits, pendingRecruitmentActions,
    }),
    getFrontierUncoveredCityKeys,
    getFrontierExtraSlots,
    /** F: казармы из candidateCells под слоты сверх потолка — в порядке F (sortW37FrontierHireCells) */
    getFrontierHireCells: (candidateCells) => sortW37FrontierHireCells({
      playerCities,
      cityKeys: getFrontierUncoveredCityKeys(),
      candidateCells,
      threatByQuarter: getThreats().threatByQuarter,
      soonCityKeys: getSoonCityKeys(),
      enemySourceKeys: getEnemySourceKeys(),
    }),
    // E: большой запас — дорогие типы первыми (на монетах начала тика)
    isRichTypes: () => features.isRichUnits && checkIfW37RichTypesApply(currentPlayer, currentPlayer.coins, knobs),
    sortRichTypes: (preference) => sortW37RichTypePreference(preference, currentPlayer, currentPlayer.coins, knobs),
    /** E: d20 после запрета с R10 — годится ли казарма cellKey (у рабочего лагеря, хватает фаз роста) */
    checkD20CampAllowed: (cellKey) => checkIfW37D20CampHireAllowed({
      round, roundLimit, isCampBarracks: getCampBarracks().has(cellKey),
    }, knobs),
    getCampBarracks,
    getArsenalBarracks,
    getFreshUnitIds,
    // A: свежий найм на казармах городов с рабочим арсеналом
    getFreshArsenalUnitIds: () => {
      if (getFreshUnitIds().size === 0) {
        return new Set();
      }
      const arsenalCells = getArsenalBarracks();
      return new Set(playerUnits
        .filter((unit) => getFreshUnitIds().has(unit.id) && arsenalCells.has(unit.hexKey))
        .map((unit) => unit.id));
    },
  };
};

// До какого раунда зверолюди предпочитают d10 (дальше — крупные лимиты d20/d12/d8)
const BEASTMEN_EARLY_ROUNDS = 6;

// Волна 42 (U1): у летуна дальность кавалерии работает в любую сторону
const W42_CELECTIALS_RECRUITMENT_TYPE_PREFERENCE = [
  UNIT_TYPES.D8.id,
  UNIT_TYPES.D12.id,
  UNIT_TYPES.D10.id,
  UNIT_TYPES.D6.id,
];

// Порядок предпочтения типов отрядов при найме (без учета фракций)
const RECRUITMENT_TYPE_PREFERENCE = [
  UNIT_TYPES.D10.id,
  UNIT_TYPES.D8.id,
  UNIT_TYPES.D6.id,
];

// Есть ли у игрока арсенал в городе с казармами (ускоренный найм размера)
const checkIfHasArsenalInBarracksCity = (currentPlayer, citiesCache) => {
  const playerCities = citiesCache?.[currentPlayer.color] || [];
  return playerCities.some((city) =>
    (city[SPECIAL_BUILDING_TOKENS.ARSENAL] || []).length > 0
    && (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).length > 0
  );
};

// Есть ли у игрока военный лагерь в городе с казармами (ускоренный рост на казарме)
const checkIfHasCampInBarracksCity = (currentPlayer, citiesCache) => {
  const playerCities = citiesCache?.[currentPlayer.color] || [];
  return playerCities.some((city) =>
    (city[SPECIAL_BUILDING_TOKENS.MILITARY_CAMP] || []).length > 0
    && (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).length > 0
  );
};

/**
 * Порядок предпочтения типов отрядов.
 * Фракционные ветки (зверолюди/демоны/крысолюды) — из рекомендаций фракций.
 * Общий порядок зависит от архетипа: d6 — только для беззащитного старта;
 * Агрессивный Rush предпочитает кавалерию d12/d8, а со связкой AGRARIANISM
 * или арсенала — линию d20/d10 (быстрый массовый рост размера).
 */
/**
 * Предпочтительные типы отрядов для найма, отфильтрованные по правилам фракции
 * (unitTypes в конфиге): бот не должен нанимать типы, недоступные его фракции —
 * у великанов это все, кроме d20. Фильтр общий с тулбаром найма игрока
 */
export const getRecruitmentTypePreference = (currentPlayer, round, playerUnits, citiesCache) => {
  const preference = resolveRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache);
  const allowedTypeIds = getRecruitableUnitTypeIds(currentPlayer);

  return preference.filter((unitTypeId) => allowedTypeIds.includes(unitTypeId));
};

const resolveRecruitmentTypePreference = (currentPlayer, round, playerUnits, citiesCache) => {
  // Волна 39: великаны нанимают единственный свой тип — d20 (у legacy общий
  // порядок ниже фильтр фракции сводит к пустому списку: найма почти нет)
  if (checkIfW39GiantsPlayer(currentPlayer)) {
    return [UNIT_TYPES.D20.id];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.BEASTMEN)) {
    return round <= BEASTMEN_EARLY_ROUNDS
      ? [UNIT_TYPES.D10.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id]
      : [UNIT_TYPES.D20.id, UNIT_TYPES.D12.id, UNIT_TYPES.D8.id, UNIT_TYPES.D10.id, UNIT_TYPES.D6.id];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.DEMONS)) {
    // Ранняя игра: d12/d20 — слишком большой вклад на старте, ограничиваемся d10,
    // а монеты идут в захват рудников строительством (d12 открывается с 4 раунда)
    if (round <= 3) {
      return [UNIT_TYPES.D10.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id];
    }
    const bigUnitsCount = playerUnits.filter(
      (unit) => (getUnitTypeConfig(unit.type)?.maxSize || 0) >= UNIT_TYPES.D10.maxSize
    ).length;
    // d20 растет слишком долго без поддержки: имеет смысл только со связкой
    // PATRIOTISM + арсенал или DESPOTISM (дешевле) + лагерь у казарм
    const hasD20Support = (isPlayerPolicy(currentPlayer, POLICIES.PATRIOTISM)
        && checkIfHasArsenalInBarracksCity(currentPlayer, citiesCache))
      || (isPlayerPolicy(currentPlayer, POLICIES.DESPOTISM)
        && checkIfHasCampInBarracksCity(currentPlayer, citiesCache));
    const bigLine = hasD20Support
      ? [UNIT_TYPES.D20.id, UNIT_TYPES.D12.id, UNIT_TYPES.D10.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id]
      : [UNIT_TYPES.D12.id, UNIT_TYPES.D10.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id];
    return bigUnitsCount < 2 ? bigLine : [UNIT_TYPES.D6.id, ...bigLine.filter((t) => t !== UNIT_TYPES.D6.id)];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.RATMEN)) {
    // Пехота у крысолюдов бесплатна (найм d6 за снабжение) — за монеты только
    // элитная кавалерия для молниеносных ударов при поддержке роя d6
    return [UNIT_TYPES.D12.id, UNIT_TYPES.D8.id];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.INSECTOIDS)) {
    // Раш ВАРВАРСТВА: +1 урона в ближнем бою каждому отряду — дешевая масса d6
    // выгоднее пары крупных (бонус политики множится на количество отрядов)
    if (isPlayerPolicy(currentPlayer, POLICIES.BARBARISM)) {
      return [UNIT_TYPES.D6.id, UNIT_TYPES.D10.id, UNIT_TYPES.D8.id];
    }
    // Инсектоиды давят количеством всегда снабженных отрядов — недорогая масса
    return [UNIT_TYPES.D10.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.DWARVES)) {
    // Гномы: приоритет d10 (при SERVARIANISM размер 7+ у рудника дает доход);
    // кавалерия d8/d12 гномам запрещена правилами фракции
    return [UNIT_TYPES.D10.id, UNIT_TYPES.D20.id, UNIT_TYPES.D6.id];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.ELVES)) {
    // Эльфы: медленный рост (+1 всюду) должен копиться с ранних раундов на
    // крупных отрядах — дебютная линия d10+d6, в середине больше d10/d8;
    // апгрейды d6->d10->d20 продолжают консолидацию
    return round <= 4
      ? [UNIT_TYPES.D10.id, UNIT_TYPES.D6.id]
      : [UNIT_TYPES.D10.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id, UNIT_TYPES.D20.id];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.LEPRECHAUNS)) {
    // Лепреконы: кража масштабируется максимальной численностью (d6 = 1 монета,
    // d10 = 2, d20 = 4) — с середины игры приоритет крупным лимитам (живой тест 14)
    return round <= 4
      ? [UNIT_TYPES.D10.id, UNIT_TYPES.D6.id]
      : [UNIT_TYPES.D20.id, UNIT_TYPES.D10.id, UNIT_TYPES.D6.id];
  }
  if (isPlayerFaction(currentPlayer, FACTIONS.VENTORY)) {
    // Волна 21 (20.4, запечено): вентори почти никогда не дорастает d20 до нужного
    // размера и не успевает довести его до противника — монеты за элитную
    // пехоту приоритетно в d10 (растет быстрее, реально доезжает до боя),
    // d20 в конце строки как редкий сток профицита (лимит 1 шт, см.
    // checkSameTypeUnitRecruitmentLimit/VENTORY_D20_SAME_TYPE_UNIT_LIMIT)
    return round <= 4
      ? [UNIT_TYPES.D10.id, UNIT_TYPES.D6.id]
      : [UNIT_TYPES.D10.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id, UNIT_TYPES.D20.id];
  }

  let basePreference;
  if (playerUnits.length === 0 && round <= 3) {
    // Беззащитный старт: дешевый d6, чтобы не остаться без армии вообще
    basePreference = [UNIT_TYPES.D6.id, UNIT_TYPES.D10.id, UNIT_TYPES.D8.id];
  } else if (checkIfW42CelectialsCavalryPlayer(currentPlayer)) {
    basePreference = W42_CELECTIALS_RECRUITMENT_TYPE_PREFERENCE;
  } else {
    const archetype = getBotStrategy(currentPlayer.id).archetype;
    if (archetype === BOT_ARCHETYPES.AGGRESSIVE_RUSH) {
      const hasMassGrowthSupport = isPlayerPolicy(currentPlayer, POLICIES.AGRARIANISM)
        || checkIfHasArsenalInBarracksCity(currentPlayer, citiesCache);
      basePreference = hasMassGrowthSupport
        ? [UNIT_TYPES.D20.id, UNIT_TYPES.D10.id, UNIT_TYPES.D12.id, UNIT_TYPES.D8.id, UNIT_TYPES.D6.id]
        : [UNIT_TYPES.D12.id, UNIT_TYPES.D8.id, UNIT_TYPES.D10.id, UNIT_TYPES.D6.id];
    } else {
      basePreference = RECRUITMENT_TYPE_PREFERENCE;
    }
  }

  // Профицит монет: элитные типы — полезный сток мертвого запаса
  if (currentPlayer.coins >= BOT_COIN_SURPLUS_THRESHOLD
    && !isPlayerFaction(currentPlayer, FACTIONS.ENLIGHTENED)
  ) {
    return [
      UNIT_TYPES.D20.id,
      UNIT_TYPES.D12.id,
      ...basePreference.filter((t) => t !== UNIT_TYPES.D20.id && t !== UNIT_TYPES.D12.id),
    ];
  }

  return basePreference;
};

/**
 * Цена самого предпочтительного типа отряда — для резерва монет в фазе строительства
 * (иначе стройка съедает все, и на войне хватает только на d6).
 */
export const getPreferredUnitPrice = (currentPlayer, round, playerUnits, citiesCache) => {
  const preference = getRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache);
  if (preference.length === 0) {
    return 0;
  }
  return getUnitPrice(preference[0], currentPlayer).price;
};

/**
 * Слоты общего потолка отрядов при найме нового отряда (tryRecruitNewUnit и
 * проверка стройки волны 35, checkIfBotCanHireNewGuardUnit): базовый потолок
 * baseUnitCap (волна 38: по лиге бота, getBotHireArmyCap; у неявных ботов и
 * legacy — UNITS_SAME_TIME_COUNT_LIMIT) плюс extraUnitSlots — точечные слоты
 * волн 27/31 (кавалерия крысолюдов, инсектоиды, не-d6 при BARBARISM)
 */
const calcNewUnitHireSlots = (state, currentPlayer, playerUnits) => {
  // Волна 27 (24.1): рой d6 (найм за снабжение, лимит по типу 6) заполняет
  // и общий ботовский потолок отрядов (эвристика ниже), и фермерский раньше,
  // чем у крысолюдов появляются деньги на кавалерию, — d8/d12 не нанимались
  // вовсе, хотя казармы под них строились. С кавалерийского раунда до 2
  // слотов сверх обоих потолков резервируются ИМЕННО под кавалерию (гейт по
  // типу в цикле найма ниже; лимит правил игры «4 отрядов одного типа»
  // по-прежнему держит checkSameTypeUnitRecruitmentLimit)
  const isRatmen = isPlayerFaction(currentPlayer, FACTIONS.RATMEN);
  const currentRound = selectRound(state);
  let ratmenCavalryExtraSlots = 0;
  if (isRatmen && currentRound >= RATMEN_CAVALRY_ROUND) {
    const cavalryCount = playerUnits.filter(
      (unit) => unit.type === UNIT_TYPES.D8.id || unit.type === UNIT_TYPES.D12.id
    ).length;
    ratmenCavalryExtraSlots = Math.max(0, 2 - cavalryCount);
  }

  // BARBARISM: d6 бесплатны и теряют без снабжения только 1 размер —
  // спамим их сверх фермерского потолка (в пределах общего лимита отрядов)
  const hasBarbarism = isPlayerPolicy(currentPlayer, POLICIES.BARBARISM);

  // Инсектоиды: все отряды всегда получают базовое снабжение — фермерский потолок
  // на них не распространяется, максимизируем количество отрядов
  const isInsectoids = isPlayerFaction(currentPlayer, FACTIONS.INSECTOIDS);

  // Волна 31 (живой тест): UNITS_SAME_TIME_COUNT_LIMIT — лимит ПРАВИЛ на отряды
  // ОДНОГО типа, но бот применял его как общий потолок армии. Для тех, чья сила
  // именно в массе, это глушило найм полностью:
  //  - инсектоиды (снабжение не нужно) стояли с казармами и монетами, но без
  //    отрядов: 4 любых отряда закрывали потолок;
  //  - BARBARISM набирал 4 бесплатных d6 и переставал нанимать ЛЮБЫЕ типы,
  //    хотя правила считают лимит по типу и d10/d8/d12 были доступны.
  // Слоты сверх базового потолка выдаются точечно и расходуются в цикле найма
  // строго на дефицитные типы (см. гейт isOverBaseUnitLimit ниже).
  // A/B волны 31: legacy-группа играет прежним общим потолком армии
  const isPreCapFix = isPreRecruitmentCapFixPlayer(currentPlayer.id);
  const insectoidsExtraSlots = isInsectoids && !isPreCapFix ? getInsectoidsExtraUnitSlots() : 0;
  // BARBARISM: слотов ровно столько, сколько потолка занял бесплатный рой d6
  const barbarismExtraSlots = hasBarbarism && !isPreCapFix
    ? Math.min(
      getBarbarismNonD6ExtraSlots(),
      playerUnits.filter((unit) => unit.type === UNIT_TYPES.D6.id).length
    )
    : 0;
  const extraUnitSlots = ratmenCavalryExtraSlots + insectoidsExtraSlots + barbarismExtraSlots;
  // Волна 38 (C, гейт isPreW38HireCapPlayer): базовый потолок — по лиге бота
  // (configs/botArmyCap), у неявных ботов и legacy — прежние 4
  const baseUnitCap = getBotHireArmyCap(currentPlayer);
  return {
    isRatmen, hasBarbarism, isInsectoids, isPreCapFix, ratmenCavalryExtraSlots, insectoidsExtraSlots, extraUnitSlots,
    baseUnitCap,
  };
};

// Тип отряда, которому доступны слоты сверх базового потолка: инсектоидам —
// любой (потолок поднят целиком, масса и есть их механика), BARBARISM — любой
// КРОМЕ d6 (рой уже занял базовый потолок), остальным (крысолюды) — только
// кавалерия d8/d12
const checkIfTypeAllowedOverBaseUnitLimit = (unitTypeId, {isInsectoids, isPreCapFix, hasBarbarism}) => {
  if (isInsectoids && !isPreCapFix) {
    return true;
  }
  return hasBarbarism && !isPreCapFix
    ? unitTypeId !== UNIT_TYPES.D6.id
    : unitTypeId === UNIT_TYPES.D8.id || unitTypeId === UNIT_TYPES.D12.id;
};

/**
 * Фермерский потолок найма нового отряда (unitsCap): не больше отрядов, чем
 * кормят фермы (у бонусного бота «сильных городов» — по емкости снабжения,
 * у крысолюдов +1, у инсектоидов — общий потолок); slots — calcNewUnitHireSlots
 */
const calcNewUnitFarmCap = (state, currentPlayer, slots) => {
  const {isRatmen, isInsectoids, isPreCapFix, ratmenCavalryExtraSlots, insectoidsExtraSlots, baseUnitCap} = slots;
  // Не наращиваем армию сверх возможностей снабжения:
  // отряды без снабжения теряют 2 размера за раунд и погибают.
  const citiesCache = selectCitiesCache(state);
  const playerCities = citiesCache?.[currentPlayer.color] || [];
  const farmsCount = playerCities.reduce(
    (sum, city) => sum + (city[COMMON_BUILDING_TOKENS.FARM] || []).length, 0
  );

  // Волна 33 («сильные города»): у бонусного бота с пакетом strongCities
  // фермерский потолок — по ЕМКОСТИ снабжения (ферма у склада кормит два
  // отряда): тыловой кластер «склад + фермы» кормит столько же отрядов,
  // сколько раньше требовало ферм по фронтирным городам (H5). Общий потолок
  // армии (4 + точечные слоты) держит проверка выше, поэтому здесь его не
  // дублируем — иначе слоты BARBARISM волны 31 оказались бы мертвыми.
  // Крысолюды играют прежней хаб-логикой (farmsCount + 1), инсектоиды — своим
  // потолком ниже
  const strongCitiesHire = getStrongCitiesHireContext(state, currentPlayer);
  const isStrongCitiesFarmCap = strongCitiesHire.strongCities && !isRatmen;

  // Крысолюды: фермы у склада снабжают больше единиц — кавалерии позволен +1 сверх потолка.
  // Инсектоиды: их армию ограничивают не фермы (снабжение не нужно), а потолок
  // отрядов — иначе «простаивающая мощность» (idleCapacityHireBoost ниже) у них
  // не срабатывала и накопления на стройку душили найм насовсем
  const unitsCap = isInsectoids && !isPreCapFix
    ? baseUnitCap + insectoidsExtraSlots
    : isStrongCitiesFarmCap
      ? calcFarmsSupplyCapacity(playerCities, selectSpecialBuildings(state)) + ratmenCavalryExtraSlots
      : (isRatmen ? farmsCount + 1 : farmsCount) + ratmenCavalryExtraSlots;
  return {citiesCache, playerCities, farmsCount, strongCitiesHire, isStrongCitiesFarmCap, unitsCap};
};

/**
 * Волна 35 (B): может ли бот нанять в этом раунде новый отряд типа unitTypeId
 * заслоном города с угрозой уровня threatLevel — те же отсечки, что у найма
 * (tryRecruitNewUnit): общий потолок отрядов (слоты сверх базового — только
 * дефицитным типам), фермерский потолок (его обходит лишь заслон против захвата
 * в этом раунде волны 32, кроме крысолюдов и BARBARISM, и бесплатный отряд) и
 * лимит правил на отряды одного типа. Казарма — дело вызывающего кода.
 * Волна 37 (T, F): w37OverCapSlots — слоты сверх общего потолка (4 + точечные
 * слоты фракций) под заслон этого города, в них тип не ограничен дефицитными;
 * 0 (по умолчанию, стройка и legacy) — прежний потолок
 */
export const checkIfBotCanHireNewGuardUnit = ({
  state, currentPlayer, playerUnits, unitTypeId, threatLevel, w37OverCapSlots = 0,
}) => {
  const slots = calcNewUnitHireSlots(state, currentPlayer, playerUnits);
  const {baseUnitCap} = slots;
  const isW37OverCapHire = w37OverCapSlots > 0
    && playerUnits.length >= baseUnitCap
    && playerUnits.length < baseUnitCap + slots.extraUnitSlots + w37OverCapSlots;
  if (!isW37OverCapHire) {
    if (playerUnits.length >= baseUnitCap + slots.extraUnitSlots) {
      return false;
    }
    if (playerUnits.length >= baseUnitCap && !checkIfTypeAllowedOverBaseUnitLimit(unitTypeId, slots)) {
      return false;
    }
  }
  const {unitsCap} = calcNewUnitFarmCap(state, currentPlayer, slots);
  const isThisRoundBlocker = threatLevel === CITY_THREAT_LEVELS.THIS_ROUND && !slots.isRatmen
    && !isPreW32DefensePlayer(currentPlayer.id) && !slots.hasBarbarism && !slots.isInsectoids;
  const {price} = getUnitPrice(unitTypeId, currentPlayer);
  if (playerUnits.length >= unitsCap && price > 0 && !slots.isInsectoids && !isThisRoundBlocker) {
    return false;
  }
  return checkSameTypeUnitRecruitmentLimit(currentPlayer, unitTypeId, playerUnits);
};

// Волна 35 (G-найм): журнал найма держателей из накоплений для харнесса и стендов
// (в проде globalThis.__w35HolderHireLog не задан): кандидаты и решение по ним.
// Песочницы прогнозов и роллаутов (store.__isBotSandbox) в журнал не пишут
const recordW35HolderHire = (store, record) => {
  if (!store.__isBotSandbox && Array.isArray(globalThis.__w35HolderHireLog)) {
    globalThis.__w35HolderHireLog.push(record);
  }
};

// Порядок срочности угрозы города: этот раунд > следующий > «скоро»
const calcW35ThreatRank = (entry) => {
  if (entry.threatLevel > CITY_THREAT_LEVELS.NONE) {
    return entry.threatLevel + 1;
  }
  return entry.isSoon ? 1 : 0;
};

/**
 * Волна 35 (G-найм, гейт isPreW35GarrisonPlayer): держатель из накоплений.
 * Обязательный по доктрине город под угрозой «скоро» и выше без держателя, до
 * свободного квартала которого этим ходом не дойдет ни один свой отряд
 * (w35.getHolderNeeds), получает заслон на своей рабочей казарме, смежной
 * свободному кварталу, если на ней нет своего отряда. Тип — самый дешевый из
 * предпочтений фракции, который с размером переживет ожидаемый урон ближайшего
 * врага (calcW35HolderSizePurchases; при угрозе этого раунда — уже в эту фазу).
 * Монеты — свободные, сверх накоплений на стройку: хватает на отряд, этот размер
 * и запас W35_HOLDER_HIRE_COIN_MARGIN. Потолки отрядов и ферм — те же, что у
 * заслона (checkIfBotCanHireNewGuardUnit); заморозка найма планировщиком и
 * казарма вне снабжения найм отменяют. Размер нанятому докупает следующий тик
 * (слабый держатель, см. decideRecruitmentStep).
 * Волна 37 (w37 — контекст createW37HireContext, null у legacy): F — у
 * фронтирного города без своего отряда рядом заслон проходит и в слоты сверх
 * потолка армии, а при большом запасе (порог W37_RICH_COINS) тип — первый по
 * предпочтению, после которого остается W37_RICH_TYPE_RESERVE, а не самый
 * дешевый; E — предпочтения фракции в порядке дорогих типов
 */
const tryW35HolderHire = (store, state, currentPlayer, playerUnits, w35, w37 = null) => {
  const needs = w35.getHolderNeeds()
    .filter((need) => need.ownOnBarracks.length === 0)
    .sort((a, b) => calcW35ThreatRank(b.entry) - calcW35ThreatRank(a.entry)
      || b.entry.cityWinPoints - a.entry.cityWinPoints
      || String(a.entry.cityKey).localeCompare(String(b.entry.cityKey)));
  if (needs.length === 0) {
    return false;
  }
  const round = selectRound(state);
  const strongCitiesHire = getStrongCitiesHireContext(state, currentPlayer);
  const savingsReserve = strongCitiesHire.isArmyPhase ? 0 : getBotStrategy(currentPlayer.id).savingsGoal?.price || 0;
  const freeCoins = currentPlayer.coins - savingsReserve;
  const record = (need, decision, extra = {}) => recordW35HolderHire(store, {
    kind: 'unit',
    round,
    playerId: currentPlayer.id,
    factionId: currentPlayer.factionId,
    cityKey: need.entry.cityKey,
    cityWinPoints: need.entry.cityWinPoints,
    threatLevel: need.entry.threatLevel,
    isSoon: need.entry.isSoon === true,
    overCap: need.entry.overCap === true,
    expectedDamage: need.entry.expectedDamage,
    coins: currentPlayer.coins,
    savingsReserve,
    decision,
    ...extra,
  });
  // Планировщик заморозил найм новых отрядов в этом раунде
  if (getPlannerMode(state, currentPlayer.id).enabled && getCachedRoundPlan(currentPlayer.id, round)?.hireFreeze) {
    needs.forEach((need) => record(need, 'freeze'));
    return false;
  }
  const hexes = selectHexes(state);
  const units = selectUnits(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const citiesCache = selectCitiesCache(state);
  const recruitmentCells = new Set(calculateAvailableRecruitmentCells(state));
  // Новый отряд вне досягаемости ферм погибнет от голода — заслон только в снабжении
  const isSupplyUnlimited = isPlayerFaction(currentPlayer, FACTIONS.INSECTOIDS)
    || isPlayerPolicy(currentPlayer, POLICIES.ECOANARCHISM);
  const playerFarms = isSupplyUnlimited ? [] : getPlayerFarms(state);
  const supplyReachCells = isSupplyUnlimited
    ? null
    : calcSupplyReachCells(playerFarms, hexes, getBotGridRenderer(state));
  // Типы — предпочтения фракции (BARBARISM — d6 первым), запрет d20 с 10 раунда
  // (кроме фракций только с d20), как у найма нового отряда
  const allowedTypeIds = getRecruitableUnitTypeIds(currentPlayer);
  const isD20OnlyFaction = allowedTypeIds.length === 1 && allowedTypeIds[0] === UNIT_TYPES.D20.id;
  // Волна 37 (E): при большом запасе предпочтения фракции — в порядке дорогих типов
  const factionPreference = w37 && w37.isRichTypes()
    ? w37.sortRichTypes(getRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache))
    : getRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache);
  const typePreference = (isPlayerPolicy(currentPlayer, POLICIES.BARBARISM)
    ? [UNIT_TYPES.D6.id, ...factionPreference.filter((typeId) => typeId !== UNIT_TYPES.D6.id)]
    : factionPreference
  ).filter((typeId) => allowedTypeIds.includes(typeId)
    && !(typeId === UNIT_TYPES.D20.id && round >= 10 && !isD20OnlyFaction));
  // Волна 37 (F): большой запас свободных монет — тип не обязательно самый дешевый
  const isW37FrontierHolder = Boolean(w37 && w37.isFrontierHire);
  const isW37RichHolder = isW37FrontierHolder && !checkIfW37CoinsArePoints(currentPlayer)
    && calcW37RichExtraSlots(freeCoins, w37.knobs) > 0;

  for (const need of needs) {
    const barracksCells = need.barracks.filter((cellKey) => recruitmentCells.has(cellKey));
    if (barracksCells.length === 0) {
      record(need, 'barracks');
      continue;
    }
    const suppliedCells = supplyReachCells
      ? barracksCells.filter((cellKey) => supplyReachCells.has(cellKey))
      : barracksCells;
    if (suppliedCells.length === 0) {
      record(need, 'supply');
      continue;
    }
    const sizePerPurchase = checkIfCityHasWorkingArsenal(
      need.city, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
    ) ? RECRUITMENT_SIZE_WITH_COINS_WITH_ARSENAL : RECRUITMENT_SIZE_WITH_COINS_DEFAULT;
    const quartersCount = getAllQuartersOfCity(need.city).filter((quarterHexKey) => !checkIfHexBlockedByEnemyUnit(
      quarterHexKey, TOKENS.QUARTER, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
    )).length;
    // Волна 37 (F): фронтирный город без своего отряда рядом — и в слоты сверх потолка армии
    const w37OverCapSlots = isW37FrontierHolder && w37.getFrontierExtraSlots() > 0
      && w37.getFrontierUncoveredCityKeys().has(need.entry.cityKey)
      ? w37.getFrontierExtraSlots()
      : 0;
    // Самый дешевый тип (отряд + размер, переживающий урон); при равенстве — по
    // предпочтению. Причина отказа — последняя отсечка, до которой дошел хоть один тип.
    // Волна 37 (F, большой запас): первый по предпочтению, после которого остается резерв
    let best = null;
    let w37Preferred = null;
    let minCost = Infinity;
    let hasViableType = false;
    let hasHireableType = false;
    typePreference.forEach((unitTypeId) => {
      const unitConfig = getUnitTypeConfig(unitTypeId);
      const sizePlan = calcW35HolderSizePurchases({
        expectedDamage: need.entry.expectedDamage,
        maxSize: unitConfig?.maxSize || 0,
        sizePerPurchase,
        quartersCount,
      });
      if (!sizePlan || (need.entry.threatLevel === CITY_THREAT_LEVELS.THIS_ROUND && !sizePlan.isEnough)) {
        return;
      }
      hasViableType = true;
      if (!checkIfBotCanHireNewGuardUnit({
        state, currentPlayer, playerUnits, unitTypeId, threatLevel: need.entry.threatLevel, w37OverCapSlots,
      })) {
        return;
      }
      hasHireableType = true;
      const {price} = getUnitPrice(unitTypeId, currentPlayer);
      const cost = price + sizePlan.purchases * getSizeRecruitmentPrice(unitConfig, currentPlayer).sizePrice;
      minCost = Math.min(minCost, cost);
      if (freeCoins >= cost + W35_HOLDER_HIRE_COIN_MARGIN && currentPlayer.coins >= price
        && (!best || cost < best.cost)
      ) {
        best = {unitTypeId, price, cost};
      }
      if (isW37RichHolder && !w37Preferred && freeCoins >= cost + W35_HOLDER_HIRE_COIN_MARGIN
        && currentPlayer.coins >= price && freeCoins - cost >= w37.knobs.richTypeReserve
      ) {
        w37Preferred = {unitTypeId, price, cost};
      }
    });
    if (w37Preferred) {
      best = w37Preferred;
    }
    if (!best) {
      record(need, !hasViableType ? 'type' : !hasHireableType ? 'cap' : 'coins',
        Number.isFinite(minCost) ? {plannedCost: minCost} : {});
      continue;
    }
    const barracksHexKey = suppliedCells[0];
    const newUnitId = createRandomId(ID_PREFIX_FOR_UNIT);
    store.dispatch(recruitUnit(barracksHexKey, best.unitTypeId, currentPlayer.factionId, best.price, newUnitId));
    const recruitedUnit = selectSharedGameState(store.getState()).units.find((unit) => unit.hexKey === barracksHexKey);
    if (!recruitedUnit) {
      return false;
    }
    store.dispatch(addPendingRecruitmentAction(recruitedUnit.id, 'UNIT_RECRUITMENT', barracksHexKey, best.price, 0));
    record(need, 'hired', {
      unitType: best.unitTypeId, price: best.price, plannedCost: best.cost, barracks: barracksHexKey,
      ...(w37Preferred ? {w37RichType: true} : {}),
    });
    return true;
  }
  return false;
};

/**
 * Волна 37 (T, гейт isPreW37ThreatHirePlayer): заслон города с угрозой захвата в
 * ЭТОМ раунде — отряды противников, которые ходят после бота, или их фантомный
 * найм (w37.getThreatGuardNeeds: держателя, который переживет урон, нет; своего
 * отряда на казарме города нет). Захват проверяется в конце раунда, а нанятый
 * сейчас отряд встает на квартал перемещением этой же фазы. Порядок городов —
 * класс угрозы, затем ценность (очки + доход). Казарма — свободная рабочая
 * казарма города, в зоне снабжения первой; вне снабжения заслон тоже ставится:
 * голод (−2) придет лишь в следующей фазе снабжения. Тип — из тех, что с
 * покупками размера в эту фазу переживут урон (pickW37GuardType): первый по
 * предпочтениям фракции (при большом запасе и E — первый из дорогих), а заслону
 * вне снабжения или сверх фермерского потолка — самый дешевый. Монеты — все, без
 * накоплений на стройку, но с запасом W37_THREAT_HIRE_COIN_MARGIN. Потолки — как
 * у заслона этого раунда волны 32 (фермерский он обходит, кроме крысолюдов,
 * BARBARISM и инсектоидов), а общий потолок армии — плюс
 * W37_THREAT_GUARD_EXTRA_SLOTS и слоты F. Заморозка найма планировщиком найм
 * отменяет. Размер нанятому докупают следующие тики (w37.getWeakGuardIds в
 * decideRecruitmentStep)
 */
const tryW37ThreatGuardHire = (store, state, currentPlayer, playerUnits, w37) => {
  const needs = w37.getThreatGuardNeeds().filter((need) => !need.hasOwnUnitOnBarracks);
  if (needs.length === 0) {
    return false;
  }
  const round = selectRound(state);
  const record = (need, decision, extra = {}) => recordW37Hire(store, {
    kind: 'threat',
    round,
    playerId: currentPlayer.id,
    factionId: currentPlayer.factionId,
    cityKey: need.cityKey,
    cityValue: need.value,
    threatRank: need.threatRank,
    level: need.entry.level,
    byRecruit: need.entry.isThisRoundByRecruit === true,
    requiredDamage: need.requiredDamage,
    coins: currentPlayer.coins,
    unitsCount: playerUnits.length,
    decision,
    ...extra,
  });
  if (getPlannerMode(state, currentPlayer.id).enabled && getCachedRoundPlan(currentPlayer.id, round)?.hireFreeze) {
    needs.forEach((need) => record(need, 'freeze'));
    return false;
  }
  const hexes = selectHexes(state);
  const units = selectUnits(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const citiesCache = selectCitiesCache(state);
  const recruitmentCells = new Set(calculateAvailableRecruitmentCells(state));
  const isSupplyUnlimited = isPlayerFaction(currentPlayer, FACTIONS.INSECTOIDS)
    || isPlayerPolicy(currentPlayer, POLICIES.ECOANARCHISM);
  const supplyReachCells = isSupplyUnlimited
    ? null
    : calcSupplyReachCells(getPlayerFarms(state), hexes, getBotGridRenderer(state));
  // Типы — как у держателя из накоплений: предпочтения фракции (E — в порядке
  // дорогих), BARBARISM — d6 первым, запрет d20 с 10 раунда (кроме фракций только с d20)
  const allowedTypeIds = getRecruitableUnitTypeIds(currentPlayer);
  const isD20OnlyFaction = allowedTypeIds.length === 1 && allowedTypeIds[0] === UNIT_TYPES.D20.id;
  const isRichTypes = w37.isRichTypes();
  const factionPreference = isRichTypes
    ? w37.sortRichTypes(getRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache))
    : getRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache);
  const typePreference = (isPlayerPolicy(currentPlayer, POLICIES.BARBARISM)
    ? [UNIT_TYPES.D6.id, ...factionPreference.filter((typeId) => typeId !== UNIT_TYPES.D6.id)]
    : factionPreference
  ).filter((typeId) => allowedTypeIds.includes(typeId)
    && !(typeId === UNIT_TYPES.D20.id && round >= 10 && !isD20OnlyFaction));
  const w37OverCapSlots = w37.knobs.threatGuardExtraSlots + w37.getFrontierExtraSlots();
  // Заслон, которого прокормят, — по предпочтениям фракции (при E — дорогой);
  // сверх фермерского потолка или вне снабжения он потеряет 2 размера в
  // следующей фазе снабжения — тогда самый дешевый тип (как d6-заслон волны 32)
  const {unitsCap} = calcNewUnitFarmCap(state, currentPlayer, calcNewUnitHireSlots(state, currentPlayer, playerUnits));
  const isFedByFarms = isSupplyUnlimited || playerUnits.length < unitsCap;

  for (const need of needs) {
    const barracksCells = (need.city[COMMON_BUILDING_TOKENS.BARRACKS] || [])
      .filter((cellKey) => recruitmentCells.has(cellKey));
    if (barracksCells.length === 0) {
      record(need, 'barracks');
      continue;
    }
    const suppliedCells = supplyReachCells
      ? barracksCells.filter((cellKey) => supplyReachCells.has(cellKey))
      : barracksCells;
    const barracksHexKey = (suppliedCells.length > 0 ? suppliedCells : barracksCells)[0];
    const sizePerPurchase = checkIfCityHasWorkingArsenal(
      need.city, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
    ) ? RECRUITMENT_SIZE_WITH_COINS_WITH_ARSENAL : RECRUITMENT_SIZE_WITH_COINS_DEFAULT;
    const quartersCount = getAllQuartersOfCity(need.city).filter((quarterHexKey) => !checkIfHexBlockedByEnemyUnit(
      quarterHexKey, TOKENS.QUARTER, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
    )).length;
    const {best, reason} = pickW37GuardType({
      typePreference,
      player: currentPlayer,
      requiredDamage: need.requiredDamage,
      sizePerPurchase,
      quartersCount,
      freeCoins: currentPlayer.coins,
      coinMargin: w37.knobs.threatHireCoinMargin,
      isFed: isFedByFarms && suppliedCells.includes(barracksHexKey),
      isRich: isRichTypes,
      richReserve: w37.knobs.richTypeReserve,
      canHire: (unitTypeId) => checkIfBotCanHireNewGuardUnit({
        state, currentPlayer, playerUnits, unitTypeId, threatLevel: CITY_THREAT_LEVELS.THIS_ROUND, w37OverCapSlots,
      }),
    });
    if (!best) {
      record(need, reason);
      continue;
    }
    const newUnitId = createRandomId(ID_PREFIX_FOR_UNIT);
    store.dispatch(recruitUnit(barracksHexKey, best.unitTypeId, currentPlayer.factionId, best.price, newUnitId));
    const recruitedUnit = selectSharedGameState(store.getState()).units.find((unit) => unit.hexKey === barracksHexKey);
    if (!recruitedUnit) {
      return false;
    }
    store.dispatch(addPendingRecruitmentAction(recruitedUnit.id, 'UNIT_RECRUITMENT', barracksHexKey, best.price, 0));
    record(need, 'hired', {
      unitType: best.unitTypeId, price: best.price, plannedCost: best.cost, barracks: barracksHexKey,
      isSupplied: suppliedCells.includes(barracksHexKey),
      isOverCap: playerUnits.length >= getBotHireArmyCap(currentPlayer),
    });
    return true;
  }
  return false;
};

// w35 — контекст найма волны 35 (createW35HireContext), null у legacy;
// w37 — контекст найма волны 37 (createW37HireContext), null у legacy
const tryRecruitNewUnit = (store, state, currentPlayer, playerUnits, w35 = null, w37 = null) => {
  const newUnitHireSlots = calcNewUnitHireSlots(state, currentPlayer, playerUnits);
  const {isRatmen, hasBarbarism, isInsectoids, extraUnitSlots, baseUnitCap} = newUnitHireSlots;
  // Волна 37 (F, гейт isPreW37FrontierHirePlayer): при большом запасе — слоты
  // сверх потолка армии только под казармы фронтирных городов без своего отряда
  // рядом (0 — нет запаса или таких казарм, у legacy — всегда: прежний потолок)
  const w37FrontierSlots = w37 && w37.isFrontierHire ? w37.getFrontierExtraSlots() : 0;

  if (playerUnits.length >= baseUnitCap + extraUnitSlots + w37FrontierSlots) {
    return false;
  }
  // Найм сверх базового потолка идет только за счет дополнительных слотов —
  // в цикле ниже он ограничивается дефицитными типами
  const isOverBaseUnitLimit = playerUnits.length >= baseUnitCap;
  // Волна 37 (F): точечные слоты фракций заняты — дальше только слоты F
  const isOverFactionUnitSlots = playerUnits.length >= baseUnitCap + extraUnitSlots;

  const {
    citiesCache, playerCities, farmsCount, strongCitiesHire, isStrongCitiesFarmCap, unitsCap,
  } = calcNewUnitFarmCap(state, currentPlayer, newUnitHireSlots);

  // Волна 32 (оборона, гейт isPreW32DefensePlayer): свободные рабочие казармы
  // городов под риском захвата без живучего держателя (уровень риска по казарме).
  // Города, где свой отряд уже на казарме (в т.ч. заслон, нанятый этой фазой),
  // пропускаются: он встает на смежный квартал перемещением, второй заслон не нужен
  const w32GuardBarracksLevels = isPreW32DefensePlayer(currentPlayer.id)
    ? null
    : getGuardNeededCityBarracks(
      getCityCaptureThreats(state, currentPlayer).cityThreats, CITY_THREAT_LEVELS.NEXT_ROUND,
      {skipCitiesWithOwnUnitOnBarracks: true}
    );
  // Волна 35 (G-найм, гейт isPreW35GarrisonPlayer): казарма открытого города
  // экономической доктрины без гарнизона — заслон, как при угрозе следующего
  // раунда (первой в порядке казарм, накопления на стройку не блокируют). До
  // угрозы модели такой город в проде стоял пустым, пока его не брали «двойным
  // ходом». Без таких казарм (и у legacy) — тот же объект w32GuardBarracksLevels
  const guardBarracksLevels = w35 ? w35.mergeGuardLevels(w32GuardBarracksLevels) : w32GuardBarracksLevels;
  const w32GuardRecruitmentCells = guardBarracksLevels && guardBarracksLevels.size > 0
    ? calculateAvailableRecruitmentCells(state).filter((cellKey) => guardBarracksLevels.has(cellKey))
    : [];
  const w32ThisRoundGuardCells = w32GuardRecruitmentCells.filter(
    (cellKey) => guardBarracksLevels.get(cellKey) === CITY_THREAT_LEVELS.THIS_ROUND
  );
  // Заслон против захвата В ЭТОМ раунде — и без ферм, и сверх фермерского потолка:
  // захват проверяется в конце раунда, голод (−2) придет лишь в следующей фазе
  // снабжения. Крысолюдов не касается: их d6 нанимаются за снабжение
  const isW32ThisRoundBlockerHire = !isRatmen && w32ThisRoundGuardCells.length > 0;
  const isW32OverFarmCapBlocker = isW32ThisRoundBlockerHire
    && playerUnits.length >= unitsCap && !hasBarbarism && !isInsectoids;


  // Волна 22 (21.17): совсем без ферм новый отряд обречен на голод — найм
  // (включая бесплатный спам d6 под BARBARISM и крысолюдскую кавалерию +1)
  // разрешен только как оборонительный заслон при противнике у кварталов
  // своего города. Инсектоиды — исключение: их отряды снабжаются без ферм
  if (farmsCount === 0 && !isInsectoids) {
    const isUnderThreatWithoutFarms = findOwnCitiesUnderThreat(
      currentPlayer, selectUnits(state), citiesCache, getBotGridRenderer(state)
    ).length > 0;
    if (!isUnderThreatWithoutFarms && !isW32ThisRoundBlockerHire) {
      return false;
    }
  }

  // Строго не больше отрядов, чем ферм: отряд без снабжения гибнет за раунд-два
  if (playerUnits.length >= unitsCap && !hasBarbarism && !isInsectoids && !isW32OverFarmCapBlocker) {
    return false;
  }

  const availableRecruitmentCells = calculateAvailableRecruitmentCells(state);
  if (availableRecruitmentCells.length === 0) {
    return false;
  }

  // Новонанятый отряд размера 1 умрет без снабжения (-2 в фазе снабжения):
  // платный найм только на казармах в зоне досягаемости ферм.
  // Исключения: инсектоиды (всегда снабжены) и ЭКОАНАРХИЗМ (снабжение везде).
  const isSupplyUnlimited = isInsectoids || isPlayerPolicy(currentPlayer, POLICIES.ECOANARCHISM);
  let supplyReachableCells = availableRecruitmentCells;
  let isRecruitmentOutOfSupplyReach = false;
  if (!isSupplyUnlimited) {
    const playerFarms = getPlayerFarms(state);
    // Волна 33 («сильные города»): цепочка снабжения тыл → кузница идет с
    // перезапуском дальности на своих фермах (как в правилах), поэтому казармы
    // кузницы в relay-досягаемости тыловых ферм считаются снабжаемыми — иначе
    // порядок H1 никогда не доходил бы до кузницы дальше 5 ячеек от фермы
    const supplyReachCells = playerFarms.length > 0
      ? (isStrongCitiesFarmCap
        ? calcSupplyReachCellsUnionWithRelay(playerFarms, selectHexes(state), getBotGridRenderer(state))
        : calcSupplyReachCells(playerFarms, selectHexes(state), getBotGridRenderer(state)))
      : new Set();
    supplyReachableCells = availableRecruitmentCells.filter((cellKey) => supplyReachCells.has(cellKey));
    if (supplyReachableCells.length === 0) {
      // Вне зоны снабжения найм оправдан только как дешевый d6-заслон при обороне
      const isUnderThreat = findOwnCitiesUnderThreat(
        currentPlayer, selectUnits(state), citiesCache, getBotGridRenderer(state)
      ).length > 0;
      if (!isUnderThreat && !isW32ThisRoundBlockerHire) {
        return false;
      }
      isRecruitmentOutOfSupplyReach = true;
      supplyReachableCells = availableRecruitmentCells;
    }
  }

  // Найм у фронта: казарма ближе к городам противника (центр/линия соприкосновения),
  // чтобы подкрепления появлялись у зоны конкуренции, а не в глубоком тылу
  if (supplyReachableCells.length > 1) {
    const enemyQuartersForHire = getEnemyQuarterHexKeys(citiesCache, currentPlayer.color);
    if (enemyQuartersForHire.size > 0) {
      const enemyDistances = calcBfsDistances(
        [...enemyQuartersForHire.keys()], selectHexes(state), getBotGridRenderer(state)
      );
      supplyReachableCells = [...supplyReachableCells].sort((a, b) =>
        (enemyDistances.get(a) ?? Infinity) - (enemyDistances.get(b) ?? Infinity)
      );
    }
  }

  // Волна 33 («сильные города», H1): у бота с пакетом strongCities и осью
  // удара порядок казарм обратный прежнему бонусному хуку ниже — он рассеивал
  // армию по одному отряду на каждый пустой город у чужих границ. Теперь:
  // (1) казармы кузницы, смежные рабочему лагерю первыми; (2) казармы
  // фронтирных городов, которые и без гарнизона, и под угрозой
  // (garrisonThreatRadius); (3) остальные — по BFS от кварталов ближайшего
  // живого противника (ось), а не любого чужого города с нейтралами. Порядок
  // после сортировки «к фронту» выше служит стабильным тай-брейком. Заслон
  // волны 32 накладывается поверх ниже. Крысолюды — прежним хуком
  const bonusProfileForHire = strongCitiesHire.bonusProfile;
  const isStrongCitiesBarracksOrder = strongCitiesHire.strongCities && strongCitiesHire.axis && !isRatmen;
  // Волна 37 (A): группа казармы в порядке ниже (ранг «сильных городов» или
  // «город без гарнизона») — порядок A действует внутри группы. null — групп нет
  const isW37CampArsenalOrder = Boolean(w37 && w37.isCampArsenalHire);
  let w37BarracksRankOf = null;
  if (isStrongCitiesBarracksOrder && supplyReachableCells.length > 1) {
    const hireAxis = strongCitiesHire.axis;
    const unitsForOrder = selectUnits(state);
    const hexesForOrder = selectHexes(state);
    const specialBuildingsForOrder = selectSpecialBuildings(state);
    const buildingsDamageForOrder = selectBuildingsDamage(state);
    const {forgeBarracks, campAdjacentBarracks} = collectForgeBarracks({
      playerCities,
      stagingCityKey: hireAxis.stagingCityKey,
      currentPlayerId: currentPlayer.id,
      units: unitsForOrder,
      hexes: hexesForOrder,
      specialBuildings: specialBuildingsForOrder,
      buildingsDamage: buildingsDamageForOrder,
    });
    const threatenedFrontierBarracks = collectThreatenedUndefendedFrontierBarracks({
      playerCities,
      classifyCity: (city) => classifyOwnCity(city, hireAxis),
      units: unitsForOrder,
      currentPlayerId: currentPlayer.id,
      threatRadius: bonusProfileForHire.garrisonThreatRadius,
    });
    supplyReachableCells = sortBarracksForStrongCities(supplyReachableCells, {
      forgeBarracks,
      campAdjacentBarracks,
      threatenedFrontierBarracks,
      enemyColorDistances: hireAxis.enemyColorQuarterDistances,
    });
    if (isW37CampArsenalOrder) {
      w37BarracksRankOf = (cellKey) => getStrongCitiesBarracksRank(
        cellKey, {forgeBarracks, campAdjacentBarracks, threatenedFrontierBarracks}
      );
    }
  } else if (bonusProfileForHire && supplyReachableCells.length > 1) {
    // Бонусный бот (см. configs/botBonusBehavior): подкрепления идут в СВОИ
    // города без гарнизона — это и есть те города, которые богатый бот
    // отстраивал у чужих границ и оставлял без единого отряда. Порядок внутри
    // групп сохраняется, то есть среди беззащитных городов по-прежнему первым
    // идет ближайший к противнику
    const unitsForGarrison = selectUnits(state);
    const undefendedCityBarracks = new Set();
    playerCities.forEach((city) => {
      const cityQuarters = getAllQuartersOfCity(city);
      const hasGarrison = unitsForGarrison.some((unit) =>
        unit.ownerId === currentPlayer.id
        && cityQuarters.some((quarterHexKey) => calcHexDistanceLocal(quarterHexKey, unit.hexKey) <= 1)
      );
      if (!hasGarrison) {
        (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).forEach(
          (barracksCellKey) => undefendedCityBarracks.add(barracksCellKey)
        );
      }
    });
    if (undefendedCityBarracks.size > 0) {
      supplyReachableCells = [
        ...supplyReachableCells.filter((cellKey) => undefendedCityBarracks.has(cellKey)),
        ...supplyReachableCells.filter((cellKey) => !undefendedCityBarracks.has(cellKey)),
      ];
      if (isW37CampArsenalOrder) {
        w37BarracksRankOf = (cellKey) => (undefendedCityBarracks.has(cellKey) ? 0 : 1);
      }
    }
  }

  // Волна 20 (19.15): эльфы с PATRIOTISM нанимают d10 в казармах города с
  // арсеналом (самый крупный по числу кварталов, если их несколько) — там же
  // ускоренная докупка размера (см. trySizeRecruitment/checkIfHasArsenalInBarracksCity)
  if (isPlayerFaction(currentPlayer, FACTIONS.ELVES)
    && isPlayerPolicy(currentPlayer, POLICIES.PATRIOTISM)
  ) {
    const arsenalCity = (citiesCache?.[currentPlayer.color] || [])
      .filter((city) => (city[SPECIAL_BUILDING_TOKENS.ARSENAL] || []).length > 0
        && (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).length > 0)
      .sort((a, b) => getAllQuartersOfCity(b).length - getAllQuartersOfCity(a).length)[0];
    if (arsenalCity) {
      const arsenalBarracksCells = new Set(arsenalCity[COMMON_BUILDING_TOKENS.BARRACKS] || []);
      const arsenalCells = supplyReachableCells.filter((cellKey) => arsenalBarracksCells.has(cellKey));
      if (arsenalCells.length > 0) {
        supplyReachableCells = [
          ...arsenalCells,
          ...supplyReachableCells.filter((cellKey) => !arsenalBarracksCells.has(cellKey)),
        ];
      }
    }
  }

  // Волна 32 (оборона): казармы городов под риском захвата — первыми, риск этого
  // раунда раньше риска следующего. Сверх фермерского потолка или без казармы
  // в зоне снабжения — только заслон d6 на казарме города под захватом в этом раунде
  if (w32GuardRecruitmentCells.length > 0) {
    const suppliedGuardCells = supplyReachableCells
      .filter((cellKey) => guardBarracksLevels.has(cellKey))
      .sort((a, b) => guardBarracksLevels.get(b) - guardBarracksLevels.get(a));
    // Снабжаемая казарма города с риском только следующего раунда не отнимает
    // найм у неснабжаемой казармы города, который захватят в этом раунде
    const hasSuppliedThisRoundGuardCell = suppliedGuardCells.some(
      (cellKey) => guardBarracksLevels.get(cellKey) === CITY_THREAT_LEVELS.THIS_ROUND
    );
    if (isW32OverFarmCapBlocker || (!hasSuppliedThisRoundGuardCell && w32ThisRoundGuardCells.length > 0)) {
      supplyReachableCells = w32ThisRoundGuardCells;
      isRecruitmentOutOfSupplyReach = true; // ниже typePreference = [d6]
    } else if (suppliedGuardCells.length > 0) {
      supplyReachableCells = [
        ...suppliedGuardCells,
        ...supplyReachableCells.filter((cellKey) => !guardBarracksLevels.has(cellKey)),
      ];
    }
  }
  // Волна 37 (A, гейт isPreW37CampArsenalHirePlayer): после заслонов волны 32 и
  // внутри групп прежнего порядка (кузница и фронтир «сильных городов», города
  // без гарнизона бонусного хука) — казармы у рабочего лагеря (рост +4 вместо +2
  // в каждой фазе снабжения), затем казармы городов с рабочим арсеналом (размер
  // за монеты ×2), потом прежний порядок. Обреченный заслон вне снабжения
  // (только d6) порядок не меняет; эльфы с PATRIOTISM уже ставят арсенал первым
  if (isW37CampArsenalOrder && supplyReachableCells.length > 1 && !isRecruitmentOutOfSupplyReach
    && !(isPlayerFaction(currentPlayer, FACTIONS.ELVES) && isPlayerPolicy(currentPlayer, POLICIES.PATRIOTISM))
  ) {
    supplyReachableCells = sortW37CampArsenalBarracks(supplyReachableCells, {
      campCells: w37.getCampBarracks(),
      arsenalCells: w37.getArsenalBarracks(),
      isPinned: (cellKey) => Boolean(guardBarracksLevels && guardBarracksLevels.has(cellKey)),
      rankOf: w37BarracksRankOf || undefined,
    });
  }
  const isW32GuardHire = guardBarracksLevels !== null && guardBarracksLevels.has(supplyReachableCells[0]);
  // Волна 37 (F): казармы под слоты сверх потолка — фронтирные города без своего
  // отряда рядом, в зоне снабжения, в порядке угроза > близость к врагу > ценность
  const w37FrontierCells = w37FrontierSlots > 0 && !isRecruitmentOutOfSupplyReach
    ? w37.getFrontierHireCells(supplyReachableCells)
    : [];

  const round = selectRound(state);
  // Планировщик: план раунда с заморозкой найма (кандидат economy_lean в
  // роллаутах) — новые отряды в этом раунде не покупаются, найм размера
  // существующих остается (дешевле за единицу силы)
  if (getPlannerMode(state, currentPlayer.id).enabled
    && getCachedRoundPlan(currentPlayer.id, round)?.hireFreeze
  ) {
    return false;
  }
  // Волна 37 (E, гейт isPreW37RichUnitsPlayer): при большом запасе дорогие типы
  // фракции — первыми (sortW37RichTypePreference); у legacy — прежний порядок
  const isW37RichTypes = Boolean(w37 && w37.isRichTypes());
  const factionPreference = isW37RichTypes
    ? w37.sortRichTypes(getRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache))
    : getRecruitmentTypePreference(currentPlayer, round, playerUnits, citiesCache);
  let typePreference = hasBarbarism
    ? [UNIT_TYPES.D6.id, ...factionPreference]
    : factionPreference;
  if (isRecruitmentOutOfSupplyReach) {
    // Обреченный на голод заслон — только самый дешевый отряд
    typePreference = [UNIT_TYPES.D6.id];
  }

  // Живой тест 16.1: TOTALITARIANISM дает +размер при найме всем типам, кроме
  // d6/d4 — усиливаемые типы становятся приоритетнее d6
  if (isPlayerPolicy(currentPlayer, POLICIES.TOTALITARIANISM)) {
    const boostedTypes = typePreference.filter(
      (id) => id !== UNIT_TYPES.D6.id && id !== UNIT_TYPES.D4.id
    );
    const plainTypes = typePreference.filter(
      (id) => id === UNIT_TYPES.D6.id || id === UNIT_TYPES.D4.id
    );
    typePreference = [...boostedTypes, ...plainTypes];
  }

  // Кросс-фазовый бюджет: монеты, накопленные под строительную цель, не тратим на войну
  const savingsReserve = getBotStrategy(currentPlayer.id).savingsGoal?.price || 0;
  // Волна 39: суккубы держат монеты на соблазнение этого хода (этап способностей
  // идет после найма и перемещения); у остальных 0
  const seductionReserve = calcW39SeductionCoinReserve(currentPlayer, selectUnits(state));

  // Волна 33 («сильные города», H3): в армейской фазе (первые 2/3 матча)
  // бонусный бот резерв под строительную цель в найме не держит — монеты
  // идут в отряды; стройка, наоборот, в эти раунды держит резерв под найм
  // (calcBonusArmyPhaseCoinReserve в decideConstructionStep)
  const isArmyPhaseHire = strongCitiesHire.isArmyPhase;

  // Волна 22 (21.1): свободная рабочая казарма в зоне снабжения + ферма под
  // нового отряда + достаточно монет — до 10 раунда включительно найм важнее
  // накоплений на строительную цель (живой тест 21: казармы/фермы простаивали,
  // пока бот копил на стройку)
  const idleCapacityHireBoost = playerUnits.length < unitsCap
    && supplyReachableCells.length > 0
    && round <= IDLE_CAPACITY_HIRE_MAX_ROUND;

  // Волна 19 (18.12, запечено): при окне немедленного захвата (беззащитный
  // чужой квартал в досягаемости от своих казарм) дешевая кавалерия d8
  // приоритетнее d12 — свежий d12 размера 1 все равно не поедет в опасное
  // место (холд перемещения)
  if (typePreference[0] === UNIT_TYPES.D12.id) {
    const enemyQuartersForCavalry = getEnemyQuarterHexKeys(citiesCache, currentPlayer.color);
    const allUnits = selectUnits(state);
    const hasImmediateCaptureWindow = [...enemyQuartersForCavalry.keys()].some((quarterHexKey) => {
      const isDefended = allUnits.some((otherUnit) => otherUnit.ownerId !== currentPlayer.id
        && calcHexDistanceLocal(otherUnit.hexKey, quarterHexKey) <= 1);
      if (isDefended) {
        return false;
      }
      return availableRecruitmentCells.some(
        (barracksCellKey) => calcHexDistanceLocal(barracksCellKey, quarterHexKey) <= 6
      );
    });
    if (hasImmediateCaptureWindow && typePreference.includes(UNIT_TYPES.D8.id)) {
      typePreference = [
        UNIT_TYPES.D8.id,
        ...typePreference.filter((typeId) => typeId !== UNIT_TYPES.D8.id),
      ];
    }
  }

  // Живой тест 15.6/16.3: d20 не успевает вырасти (лимит 20 при росте с 1) —
  // запрет с 10-го раунда, даже 4 раундов роста мало, дешевле дорастить d10
  const d20BanFromRound = 10;

  // Волна 19 (18.10): экономический архетип с 2 d20 больше d20 не нанимает
  // (данные v13: у раш-архетипа d20 коррелирует с проигрышем, дорогая элита
  // без пехотной линии — мертвый капитал)
  const currentArchetype = getBotStrategy(currentPlayer.id).archetype;
  const isEconomicArchetype = currentArchetype === BOT_ARCHETYPES.ECONOMIC_COINS
    || currentArchetype === BOT_ARCHETYPES.ECONOMIC_POINTS;
  const ownD20Count = playerUnits.filter((unit) => unit.type === UNIT_TYPES.D20.id).length;

  // Правила фракции: типы, недоступные фракции игрока, отсекаются и здесь —
  // ветки выше (BARBARISM, дешевый заслон вне снабжения) дописывают d6 в
  // предпочтения уже после фракционного фильтра
  const allowedTypeIds = getRecruitableUnitTypeIds(currentPlayer);
  // Фракции, которым доступен ТОЛЬКО d20 (великаны): ограничения на d20 ниже
  // писались, когда он был одним вариантом из многих, — здесь они означали бы
  // полный отказ от найма. У великанов d20 к тому же растет без лимита 20,
  // ради которого запрет с 10 раунда и вводился
  const isD20OnlyFaction = allowedTypeIds.length === 1
    && allowedTypeIds[0] === UNIT_TYPES.D20.id;

  // Волна 35 (R, гейт isPreW35LateHirePlayer): в последних раундах партии новый
  // отряд — только заслон угрожаемого города или под цель, до которой он успеет
  // дойти (у Просветленных и FANATICISM — только заслон). В проде новые отряды
  // R12 отдавали врагу больше очков, чем приносили
  const lateHireCellCheck = w35 && w35.isFinalWindow ? w35.checkNewUnitCell : null;

  // Волна 39: следующий великан — только когда уже нанятые доросли (заслон
  // угрожаемого города — исключение: город дороже)
  if (checkIfW39GiantsPlayer(currentPlayer) && !isW32GuardHire
    && !checkIfW39GiantsHireAllowed(playerUnits, playerCities.length)
  ) {
    return false;
  }

  for (const unitTypeId of typePreference) {
    if (!allowedTypeIds.includes(unitTypeId)) {
      continue;
    }
    // Волна 37 (E): при большом запасе d20 в раунде запрета годится на казарме у
    // рабочего лагеря (рост +4 успевает) — казарма проверяется после ее выбора ниже
    const isD20Banned = unitTypeId === UNIT_TYPES.D20.id && round >= d20BanFromRound && !isD20OnlyFaction;
    const isW37D20CampCandidate = isD20Banned && isW37RichTypes;
    if (isD20Banned && !isW37D20CampCandidate) {
      continue;
    }
    if (unitTypeId === UNIT_TYPES.D20.id
      && isEconomicArchetype
      && ownD20Count >= 2
      && !isD20OnlyFaction
    ) {
      continue;
    }
    // Волна 37 (F): сверх точечных слотов фракций (или тип им не положен) найм —
    // только на слот F, на казарме фронтирного города без своего отряда рядом
    const isW37FrontierSlotHire = w37FrontierCells.length > 0 && isOverBaseUnitLimit
      && (isOverFactionUnitSlots || !checkIfTypeAllowedOverBaseUnitLimit(unitTypeId, newUnitHireSlots));
    // Волна 27 (24.1): слоты сверх общего ботовского потолка — только под
    // кавалерию d8/d12 (d6 барбаризма и прочие типы их не занимают)
    // Слоты сверх базового потолка тратятся строго на дефицитные типы
    // (checkIfTypeAllowedOverBaseUnitLimit)
    if (isOverBaseUnitLimit && !checkIfTypeAllowedOverBaseUnitLimit(unitTypeId, newUnitHireSlots)
      && !isW37FrontierSlotHire) {
      continue;
    }
    // Волна 35 (R): казарма — первая в прежнем порядке, что годится под этот тип
    // (скорость типа решает досягаемость цели); подходящей нет — тип пропускается
    let barracksHexKey = supplyReachableCells[0];
    let isGuardHire = isW32GuardHire;
    if (isW37FrontierSlotHire) {
      // Волна 37 (F): первая казарма в порядке F, которая годится и окну конца партии (R)
      barracksHexKey = w37FrontierCells.find(
        (cellKey) => !lateHireCellCheck || lateHireCellCheck(cellKey, unitTypeId, guardBarracksLevels)
      );
      if (!barracksHexKey) {
        continue;
      }
      isGuardHire = guardBarracksLevels !== null && guardBarracksLevels.has(barracksHexKey);
    } else if (isOverFactionUnitSlots) {
      // Слоты F есть, но фронтирной казармы в снабжении нет — сверх потолка найма нет
      continue;
    } else if (lateHireCellCheck) {
      barracksHexKey = supplyReachableCells.find(
        (cellKey) => lateHireCellCheck(cellKey, unitTypeId, guardBarracksLevels)
      );
      if (!barracksHexKey) {
        continue;
      }
      isGuardHire = guardBarracksLevels !== null && guardBarracksLevels.has(barracksHexKey);
    }
    if (isW37D20CampCandidate && !w37.checkD20CampAllowed(barracksHexKey)) {
      continue;
    }
    const {price} = getUnitPrice(unitTypeId, currentPlayer);
    if (currentPlayer.coins < price) {
      continue;
    }
    // Волна 32 (оборона): найм на казарме угрожаемого города накопления на стройку не блокируют.
    // Волна 33: в армейской фазе бонусного бота — тоже (isArmyPhaseHire)
    if (price > 0 && currentPlayer.coins - price < savingsReserve
      && !idleCapacityHireBoost && !isGuardHire && !isArmyPhaseHire
    ) {
      continue;
    }
    if (price > 0 && currentPlayer.coins - price < seductionReserve && !isGuardHire) {
      continue;
    }
    // Сверх фермерского потолка — только бесплатные отряды (барбаризм)
    // либо инсектоиды (их отряды снабжаются без ферм), либо заслон волны 32
    if (playerUnits.length >= unitsCap && price > 0 && !isInsectoids && !isW32OverFarmCapBlocker) {
      continue;
    }
    if (!checkSameTypeUnitRecruitmentLimit(currentPlayer, unitTypeId, playerUnits)) {
      continue;
    }

    const newUnitId = createRandomId(ID_PREFIX_FOR_UNIT);

    store.dispatch(recruitUnit(
      barracksHexKey,
      unitTypeId,
      currentPlayer.factionId,
      price,
      newUnitId,
    ));

    const updatedState = store.getState();
    const updatedSharedGameState = selectSharedGameState(updatedState);
    const recruitedUnit = updatedSharedGameState.units.find((unit) => unit.hexKey === barracksHexKey);
    if (!recruitedUnit) {
      return false;
    }

    store.dispatch(addPendingRecruitmentAction(recruitedUnit.id, 'UNIT_RECRUITMENT', barracksHexKey, price, 0));
    if (w37 && Array.isArray(globalThis.__w37HireLog)) {
      recordW37Hire(store, {
        kind: isW37FrontierSlotHire ? 'frontier' : 'unit',
        round,
        playerId: currentPlayer.id,
        factionId: currentPlayer.factionId,
        unitType: unitTypeId,
        price,
        barracks: barracksHexKey,
        coins: currentPlayer.coins,
        unitsCount: playerUnits.length,
        isRichTypes: isW37RichTypes,
        isCamp: w37.isCampArsenalHire || isW37D20CampCandidate ? w37.getCampBarracks().has(barracksHexKey) : null,
        isArsenal: w37.isCampArsenalHire ? w37.getArsenalBarracks().has(barracksHexKey) : null,
      });
    }
    return true;
  }

  return false;
};

// Апгрейды эльфов и лепреконов: консолидация в крупные отряды d6 -> d10 -> d20
const UPGRADE_PATHS = {
  [UNIT_TYPES.D6.id]: UNIT_TYPES.D10.id,
  [UNIT_TYPES.D10.id]: UNIT_TYPES.D20.id,
};

/**
 * Апгрейд отряда на своей рабочей казарме (зеркало SelectedUnitStats/UnitUpgradeModal):
 * dispatch upgradeUnit с ценой из конфига UNIT_UPGRADES. Один апгрейд за тик.
 */
export const tryUnitUpgrade = (store, state, currentPlayer, playerUnits) => {
  const hexes = selectHexes(state);
  const units = selectUnits(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const citiesCache = selectCitiesCache(state);
  const playerCities = citiesCache?.[currentPlayer.color] || [];
  // Волна 33 (H3): в армейской фазе бонусного бота резерв под стройку
  // улучшение не держит (у остальных — как прежде)
  const savingsReserve = getStrongCitiesHireContext(state, currentPlayer).isArmyPhase
    ? 0
    : getBotStrategy(currentPlayer.id).savingsGoal?.price || 0;

  for (const unit of playerUnits) {
    const targetTypeId = UPGRADE_PATHS[unit.type];
    if (!targetTypeId) {
      continue;
    }
    // Апгрейдим подросшие отряды (~50% лимита, пока отряд еще стоит на казарме —
    // с 60% он уже уходит в поле): размер сохраняется, лимит растет
    const currentMaxSize = getUnitTypeConfig(unit.type)?.maxSize || 0;
    if (unit.size < Math.ceil(currentMaxSize * 0.5)) {
      continue;
    }
    // Только на СВОЕЙ рабочей казарме (UI-гейты)
    if (hexes[unit.hexKey] !== COMMON_BUILDING_TOKENS.BARRACKS) {
      continue;
    }
    const isOwnBarracks = playerCities.some((city) =>
      (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).includes(unit.hexKey)
    );
    if (!isOwnBarracks) {
      continue;
    }
    if (checkIfHexBlockedByEnemyUnit(
      unit.hexKey, TOKENS.BARRACKS, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
    )) {
      continue;
    }

    const upgradeOption = (UNIT_UPGRADES[unit.type] || []).find((option) => option.toId === targetTypeId);
    if (!upgradeOption) {
      continue;
    }
    // Лимит отрядов одного типа (как у найма): редьюсер отклонит улучшение
    // сверх лимита, а бот счел бы его сделанным и повторял бы каждый тик
    if (checkIfUnitTypeChangeExceedsLimit(unit.id, targetTypeId, currentPlayer, units)) {
      continue;
    }
    if (currentPlayer.coins < upgradeOption.price
      || currentPlayer.coins - upgradeOption.price < savingsReserve
    ) {
      continue;
    }

    store.dispatch(upgradeUnit(unit.id, unit.type, upgradeOption.toId, upgradeOption.price));
    return true;
  }

  return false;
};

// Волна 32 (армия, A5): 36% отрядов бота в R9-13 на максимуме размера, 44% из них d6.
// Улучшение поднимает лимит без слота, фермы и действия стройки.
// Исключены: эльфы и лепреконы (своя ветка tryUnitUpgrade), рои крысолюдов и
// инсектоидов (монеты — в новые отряды), просвещенные (монета = очко)
const W32_UNIT_UPGRADE_EXCLUDED_FACTIONS = new Set([
  FACTIONS.ELVES, FACTIONS.LEPRECHAUNS, FACTIONS.RATMEN, FACTIONS.INSECTOIDS, FACTIONS.ENLIGHTENED,
]);

// Волна 32 (армия, A5): свои отряды на казармах угрожаемых городов — те же
// казармы, что ставит первыми докупка размера (trySizeRecruitment): угроза
// радиуса 2 и, у новой группы обороны, риск захвата по досягаемости
const getW32ThreatenedBarracksDefenders = (state, currentPlayer, playerUnits, units) => {
  const threatenedBarracks = new Set();
  findOwnCitiesUnderThreat(currentPlayer, units, selectCitiesCache(state), getBotGridRenderer(state))
    .forEach(({city}) => (city[COMMON_BUILDING_TOKENS.BARRACKS] || [])
      .forEach((barracksCellKey) => threatenedBarracks.add(barracksCellKey)));
  if (!isPreW32DefensePlayer(currentPlayer.id)) {
    getGuardNeededCityBarracks(getCityCaptureThreats(state, currentPlayer).cityThreats, CITY_THREAT_LEVELS.NEXT_ROUND)
      .forEach((level, barracksCellKey) => threatenedBarracks.add(barracksCellKey));
  }
  if (threatenedBarracks.size === 0) {
    return [];
  }
  const hexes = selectHexes(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  return playerUnits
    // Как в trySizeRecruitment: на заблокированной казарме размер не купить
    .filter((unit) => threatenedBarracks.has(unit.hexKey) && !checkIfHexBlockedByEnemyUnit(
      unit.hexKey, TOKENS.BARRACKS, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
    ))
    .map((unit) => ({
      id: unit.id,
      size: unit.size,
      maxSize: getUnitTypeConfig(unit.type)?.maxSize || 0,
      hasEnemyInReach: units.some((otherUnit) => otherUnit.ownerId !== currentPlayer.id
        && otherUnit.ownerId !== NEUTRAL_PLAYER_ID
        && calcHexDistanceLocal(otherUnit.hexKey, unit.hexKey) <= 3),
    }));
};

const tryW32UnitUpgrade = (store, state, currentPlayer, playerUnits) => {
  if (W32_UNIT_UPGRADE_EXCLUDED_FACTIONS.has(currentPlayer.factionId)) {
    return false;
  }
  const config = getW32ArmyConfig();
  const round = selectRound(state);
  if (!round || round < config.upgradeFromRound) {
    return false;
  }
  const hexes = selectHexes(state);
  const unitsOnBarracks = playerUnits.filter((unit) => hexes[unit.hexKey] === COMMON_BUILDING_TOKENS.BARRACKS);
  if (unitsOnBarracks.length === 0) {
    return false;
  }
  const units = selectUnits(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const playerCities = selectCitiesCache(state)?.[currentPlayer.color] || [];
  const strategy = getBotStrategy(currentPlayer.id);
  // Волна 33 (H3): в армейской фазе бонусного бота накопления на стройку
  // улучшение не держит — остается только минимальный остаток монет
  const upgradeSavingsReserve = getStrongCitiesHireContext(state, currentPlayer).isArmyPhase
    ? 0
    : strategy.savingsGoal?.price || 0;
  const coinFloor = Math.max(upgradeSavingsReserve, config.upgradeCoinFloor);
  const isEconomicArchetype = strategy.archetype === BOT_ARCHETYPES.ECONOMIC_COINS
    || strategy.archetype === BOT_ARCHETYPES.ECONOMIC_POINTS;
  const ownD20Count = playerUnits.filter((unit) => unit.type === UNIT_TYPES.D20.id).length;
  let threatenedDefenders = null;

  for (const unit of unitsOnBarracks) {
    const upgradeOption = pickW32UnitUpgrade({
      unitType: unit.type,
      unitSize: unit.size,
      round,
      availableUpgrades: getAvailableUnitUpgrades(unit.type, unit.factionId),
      isEconomicArchetype,
      ownD20Count,
    }, config);
    if (!upgradeOption || currentPlayer.coins - upgradeOption.price < coinFloor) {
      continue;
    }
    // UI-гейты улучшения (SelectedUnitStats): своя рабочая казарма
    const isOwnBarracks = playerCities.some((city) =>
      (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).includes(unit.hexKey));
    if (!isOwnBarracks || checkIfHexBlockedByEnemyUnit(
      unit.hexKey, TOKENS.BARRACKS, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
    )) {
      continue;
    }
    // Лимит правил на отряды одного типа (улучшаемый отряд еще старого типа)
    if (!checkSameTypeUnitRecruitmentLimit(currentPlayer, upgradeOption.toId, playerUnits)) {
      continue;
    }
    // Монеты нужнее докупке размера защитнику угрожаемого города (она идет в
    // этапе после улучшения). Защитники считаются один раз на вызов и только
    // когда нашелся кандидат
    if (threatenedDefenders === null) {
      threatenedDefenders = getW32ThreatenedBarracksDefenders(state, currentPlayer, playerUnits, units);
    }
    if (checkIfW32UpgradeYieldsToDefender({candidateUnitId: unit.id, threatenedDefenders})) {
      continue;
    }
    store.dispatch(upgradeUnit(unit.id, unit.type, upgradeOption.toId, upgradeOption.price));
    return true;
  }
  return false;
};

const trySizeRecruitment = (store, state, currentPlayer, playerUnits, options = {}) => {
  // Волна 23 (22.6): эльфы с PATRIOTISM тратят все монеты на докупку размера
  // отрядам на казармах (скидка политики) — обходятся гейты почти-полного
  // отряда и резерва накоплений.
  // Волна 35: unitFilter — размер только этим отрядам (null — любым на казармах,
  // как прежде); w35 — контекст найма волны 35 (null у legacy).
  // Волна 37: w37 — контекст найма волны 37 (null у legacy); w37ForceUnitIds (T) —
  // заслоны угрожаемых в этом раунде городов: их размер не держат ни гейт почти
  // полного отряда, ни накопления, ни фракционные отсечки орков и лепреконов
  const {elfPatriotismAllIn = false, unitFilter = null, w35 = null, w37 = null, w37ForceUnitIds = null} = options;
  // Волна 35 (G-найм): слабые держатели гарнизонов открытых городов — первые после
  // заслонов угрожаемых городов (держатель-одиночка в проде — медиана размера 3
  // против захватчика 7); пока город под угрозой «скоро» и выше, их размер
  // накопления на стройку не блокируют. У legacy оба множества null
  const w35WeakHolderIds = w35 && w35.isGarrisonHire ? w35.getWeakHolderIds() : null;
  const w35SavingsBypassHolderIds = w35 && w35.isGarrisonHire ? w35.getSavingsBypassHolderIds() : null;
  const hexes = selectHexes(state);
  const units = selectUnits(state);
  const citiesCache = selectCitiesCache(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const pendingRecruitmentActions = selectPendingRecruitmentActions(state);

  const playerCities = citiesCache?.[currentPlayer.color] || [];
  const isLeprechaunsPlayer = isPlayerFaction(currentPlayer, FACTIONS.LEPRECHAUNS);
  const seductionReserve = calcW39SeductionCoinReserve(currentPlayer, units);
  const isOrcsPlayer = isPlayerFaction(currentPlayer, FACTIONS.ORCS);

  // Орки: найм размера d6 оправдан только при близкой слабой цели — агрессия
  // в ближайшие 1-2 раунда (живой тест 14). Дистанции до кварталов противников
  // с армией слабее своей считаем один раз на вызов.
  let orcWeakTargetDistances = null;
  if (isOrcsPlayer) {
    const ownArmyForOrcs = calcPlayerArmyStrength(currentPlayer.id, units);
    const players = selectPlayers(state);
    const weakQuarterCells = [];
    getEnemyQuarterHexKeys(citiesCache, currentPlayer.color).forEach((cityInfo, quarterHexKey) => {
      if (cityInfo.color === NEUTRAL_PLAYER_COLOR) {
        weakQuarterCells.push(quarterHexKey); // нейтральный гарнизон слаб — легитимная цель
        return;
      }
      const owner = players.find((player) => player.color === cityInfo.color);
      if (owner && calcPlayerArmyStrength(owner.id, units) <= ownArmyForOrcs) {
        weakQuarterCells.push(quarterHexKey);
      }
    });
    orcWeakTargetDistances = weakQuarterCells.length > 0
      ? calcBfsDistances(weakQuarterCells, selectHexes(state), getBotGridRenderer(state))
      : new Map();
  }

  // Волна 19 (18.13, запечено): казармы городов под угрозой — их отряды первые
  // кандидаты на докупку размера (нанятый под оборону отряд доводится до
  // максимума в той же фазе перед перемещением на защиту)
  const threatenedCityBarracks = new Set();
  findOwnCitiesUnderThreat(currentPlayer, units, citiesCache, getBotGridRenderer(state))
    .forEach((threat) => {
      (threat.city[COMMON_BUILDING_TOKENS.BARRACKS] || []).forEach(
        (barracksCellKey) => threatenedCityBarracks.add(barracksCellKey)
      );
    });
  // Волна 32 (оборона, гейт isPreW32DefensePlayer): казармы городов под риском по
  // досягаемости — в приоритет докупки размера, и накопления их не блокируют
  const w32GuardBarracks = isPreW32DefensePlayer(currentPlayer.id)
    ? null
    : getGuardNeededCityBarracks(
      getCityCaptureThreats(state, currentPlayer).cityThreats, CITY_THREAT_LEVELS.NEXT_ROUND
    );
  if (w32GuardBarracks) {
    w32GuardBarracks.forEach((level, barracksCellKey) => threatenedCityBarracks.add(barracksCellKey));
  }

  // Волна 20 (19.4): казармы городов в центральной зоне поля (<=4 ячеек от
  // центра) — второй по приоритету кандидат на докупку размера (после угрозы),
  // защитники ключевых точек центра нужны в первую очередь
  const centralCityBarracks = new Set();
  (citiesCache?.[currentPlayer.color] || []).forEach((city) => {
    (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).forEach((barracksCellKey) => {
      if (calcHexDistanceLocal(barracksCellKey, '0,0') <= 4) {
        centralCityBarracks.add(barracksCellKey);
      }
    });
  });

  // Волна 33 («сильные города»): H4 — у бота с пакетом strongCities между
  // угрозой и центром поля идет город с РАБОЧИМ арсеналом (2 размера за
  // квартал вместо 1 — бонусные монеты конвертируются в силу вдвое быстрее);
  // H3 — в армейской фазе резерв под стройку докупку размера не держит.
  // У остальных arsenalCityBarracks = null, и сравнение ниже дает 0 —
  // прежний порядок дословно
  const strongCitiesSize = getStrongCitiesHireContext(state, currentPlayer);
  // Волна 37 (A): приоритет арсенала в размере — и у «большого» (BIG, без пакета
  // strongCities), а свежий найм этой фазы — раньше арсенала (после угрозы и
  // слабых держателей): он стоит на казарме, ему расти в первую очередь
  const isW37CampArsenalSize = Boolean(w37 && w37.isCampArsenalHire);
  const arsenalCityBarracks = strongCitiesSize.strongCities || isW37CampArsenalSize
    ? collectArsenalCityBarracks({
      playerCities, currentPlayerId: currentPlayer.id, units, hexes, specialBuildings, buildingsDamage,
    })
    : null;
  const w37FreshUnitIds = isW37CampArsenalSize ? w37.getFreshUnitIds() : null;

  // Отряды на своих РАБОТАЮЩИХ казармах — кандидаты на найм размера, крупные
  // типы приоритетнее. Казарма, заблокированная отрядом противника или
  // повреждениями, по правилам найм не производит (зеркало checkIfOnWorkingBarracks)
  const unitsOnBarracks = playerUnits
    .filter((unit) => hexes[unit.hexKey] === COMMON_BUILDING_TOKENS.BARRACKS
      && !checkIfHexBlockedByEnemyUnit(
        unit.hexKey, TOKENS.BARRACKS, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
      ))
    .sort((a, b) => {
      const threatDiff = Number(threatenedCityBarracks.has(b.hexKey))
        - Number(threatenedCityBarracks.has(a.hexKey));
      if (threatDiff !== 0) return threatDiff;
      const weakHolderDiff = w35WeakHolderIds
        ? Number(w35WeakHolderIds.has(b.id)) - Number(w35WeakHolderIds.has(a.id))
        : 0;
      if (weakHolderDiff !== 0) return weakHolderDiff;
      const freshDiff = w37FreshUnitIds
        ? Number(w37FreshUnitIds.has(b.id)) - Number(w37FreshUnitIds.has(a.id))
        : 0;
      if (freshDiff !== 0) return freshDiff;
      const arsenalDiff = arsenalCityBarracks
        ? Number(arsenalCityBarracks.has(b.hexKey)) - Number(arsenalCityBarracks.has(a.hexKey))
        : 0;
      if (arsenalDiff !== 0) return arsenalDiff;
      const centralDiff = Number(centralCityBarracks.has(b.hexKey))
        - Number(centralCityBarracks.has(a.hexKey));
      if (centralDiff !== 0) return centralDiff;
      const maxSizeDiff = (getUnitTypeConfig(b.type)?.maxSize || 0) - (getUnitTypeConfig(a.type)?.maxSize || 0);
      if (maxSizeDiff !== 0) return maxSizeDiff;
      return b.size - a.size;
    });

  for (const unit of unitsOnBarracks) {
    if (unitFilter && !unitFilter.has(unit.id)) {
      continue;
    }
    // Волна 37 (T): заслону города с угрозой этого раунда размер нужен в эту фазу
    const isW37ForcedSize = Boolean(w37ForceUnitIds && w37ForceUnitIds.has(unit.id));
    // Волна 19 (18.5, запечено): почти полный отряд (>= 80% максимума или >
    // максимум-2) размер за монеты не докупает — остаток дорастет от
    // снабжения. Исключение: отряд противника в досягаемости одного
    // перемещения (или наш отряд сам готов дойти до противника) — тогда
    // доводим до максимума. Волна 35 (G-найм): слабому держателю гарнизона
    // размер нужен до того, как враг подойдет, — гейт его не касается
    if (!elfPatriotismAllIn && !(w35WeakHolderIds && w35WeakHolderIds.has(unit.id)) && !isW37ForcedSize) {
      // Волна 39: великану — до цели роста фракции, а не до 20 типа d20
      const unitMaxSize = getW39GrowthMaxSize(unit, getUnitTypeConfig(unit.type)?.maxSize || 0);
      const isNearFull = unit.size >= unitMaxSize * 0.8 || unit.size > unitMaxSize - 2;
      if (isNearFull) {
        const hasEnemyInReach = units.some((otherUnit) =>
          otherUnit.ownerId !== currentPlayer.id
          && otherUnit.ownerId !== NEUTRAL_PLAYER_ID
          && calcHexDistanceLocal(otherUnit.hexKey, unit.hexKey) <= 3);
        if (!hasEnemyInReach) {
          continue;
        }
      }
    }
    // Лепреконы: размер покупается только отрядам с < 80% максимума —
    // остаток дорастет от снабжения (живой тест 14)
    if (isLeprechaunsPlayer && !isW37ForcedSize && unit.size >= (getUnitTypeConfig(unit.type)?.maxSize || 0) * 0.8) {
      continue;
    }
    // Орки: d6 с размером 4 дорастет снабжением сам; без слабой цели в
    // дистанции 8 покупка размера d6 не конвертируется в захваты
    if (isOrcsPlayer && unit.type === UNIT_TYPES.D6.id && !isW37ForcedSize) {
      if (unit.size >= 4) {
        continue;
      }
      if ((orcWeakTargetDistances?.get(unit.hexKey) ?? Infinity) > 8) {
        continue;
      }
    }
    const cityWhereUnitStands = playerCities.find((city) => {
      const cityBarracks = city[COMMON_BUILDING_TOKENS.BARRACKS];
      return Array.isArray(cityBarracks) && cityBarracks.includes(unit.hexKey);
    });
    if (!cityWhereUnitStands) {
      continue;
    }

    const sizeToAdd = calcCoinsRecruitmentSize(
      cityWhereUnitStands, currentPlayer.id, units, unit, pendingRecruitmentActions, hexes, specialBuildings, buildingsDamage
    );
    if (sizeToAdd === 0) {
      continue;
    }

    const unitConfig = getUnitTypeConfig(unit.type);
    const {sizePrice} = getSizeRecruitmentPrice(unitConfig, currentPlayer);
    if (currentPlayer.coins < sizePrice) {
      continue;
    }
    // Кросс-фазовый бюджет: не залезаем в накопления на строительную цель.
    // При глубоком профиците резерв не блокирует: мертвый капитал идет в размер.
    // Эльфы-PATRIOTISM (волна 23): все монеты идут в размер, резерв не держим.
    // Планировщик (новая архитектура): в последних 2 раундах резерв не держится
    // вовсе — стройка уже не окупится, а монеты конвертируются лишь 2:1,
    // размер же довершает захваты. Волна 35 (R): последние 2 раунда — по лимиту
    // самой партии (без лимита конца партии нет)
    const plannerEndgameRound = w35 && w35.isLateHire
      ? (w35.roundLimit === null ? Infinity : w35.roundLimit - 1)
      : FINAL_ROUND - 1;
    const plannerEndgameAllIn = getPlannerMode(state, currentPlayer.id).enabled
      && selectRound(state) >= plannerEndgameRound
      // На дуэльных полях планировщик отключен целиком (план с disabled=true)
      && !getCachedRoundPlan(currentPlayer.id, selectRound(state))?.disabled;
    const savingsReserve = getBotStrategy(currentPlayer.id).savingsGoal?.price || 0;
    if (!elfPatriotismAllIn && !plannerEndgameAllIn
      && currentPlayer.coins < BOT_COIN_DEEP_SURPLUS
      && currentPlayer.coins - sizePrice < savingsReserve
      && !(w32GuardBarracks && w32GuardBarracks.has(unit.hexKey))
      && !strongCitiesSize.isArmyPhase // Волна 33 (H3)
      && !(w35SavingsBypassHolderIds && w35SavingsBypassHolderIds.has(unit.id)) // Волна 35 (G-найм)
      && !isW37ForcedSize // Волна 37 (T)
    ) {
      continue;
    }
    // Волна 39: монеты на соблазнение этого хода (у не-суккубов резерв 0)
    if (currentPlayer.coins - sizePrice < seductionReserve
      && !(w32GuardBarracks && w32GuardBarracks.has(unit.hexKey)) && !isW37ForcedSize
    ) {
      continue;
    }

    const availableQuarters = getAllQuartersOfCity(cityWhereUnitStands).filter((quarterHexKey) => {
      const isQuarterAlreadyUsed = pendingRecruitmentActions.some(
        (action) => action.quarterHexKey === quarterHexKey
      );
      if (isQuarterAlreadyUsed) {
        return false;
      }
      return !checkIfHexBlockedByEnemyUnit(
        quarterHexKey, TOKENS.QUARTER, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage
      );
    });

    if (availableQuarters.length === 0) {
      continue;
    }

    store.dispatch(addPendingRecruitmentAction(unit.id, 'SIZE_RECRUITMENT', availableQuarters[0], sizePrice, sizeToAdd));
    return true;
  }

  return false;
};

/**
 * Этап найма фазы войны: одно действие найма за тик.
 * Приоритет: новый отряд на свободной казарме, затем найм размера с кварталов.
 * В последнем раунде найм не окупается — пропускаем этап.
 */
export const decideRecruitmentStep = (store) => {
  const state = store.getState();
  const round = selectRound(state);

  if (checkIfFinalRound(state)) {
    return false;
  }

  const currentPlayer = selectCurrentPlayer(state);
  const units = selectUnits(state);
  const playerUnits = getPlayerUnits(currentPlayer, units);
  // Волна 32 (оборона, гейт isPreW32DefensePlayer): риск захвата по досягаемости
  // открывает найм размера так же, как угроза радиуса 2 (у legacy всегда false)
  const hasW32GuardNeed = () => !isPreW32DefensePlayer(currentPlayer.id)
    && getGuardNeededCityBarracks(
      getCityCaptureThreats(state, currentPlayer).cityThreats, CITY_THREAT_LEVELS.NEXT_ROUND
    ).size > 0;
  // Волна 35 (R и G-найм): контекст на этот вызов; null — legacy по обеим подчастям
  const w35 = createW35HireContext(state, currentPlayer);
  const isW35LateHire = Boolean(w35 && w35.isLateHire);
  // Волна 35 (R): в окне конца партии размер — только отрядам в контакте,
  // держателям открытых и угрожаемых городов и под досягаемую цель
  const getW35FinalWindowSizeFilter = () => (
    isW35LateHire && w35.isFinalWindow ? w35.getLateSizeUnitIds(playerUnits) : null
  );
  // Волна 35: слабые держатели гарнизонов (G-найм); пустое множество — нет таких
  const getW35WeakHolderIds = () => (w35 && w35.isGarrisonHire ? w35.getWeakHolderIds() : new Set());
  // Волна 37 (T, F, E, A — боты «золото+»): контекст на этот вызов; null — legacy по всем подчастям
  const w37 = createW37HireContext(state, currentPlayer, playerUnits);

  // Планировщик: план раунда строится (или выбирается роллаутами) в НАЧАЛЕ
  // фазы войны — этап найма идет до перемещения, и заморозка найма кандидата
  // должна действовать уже здесь. Перемещение возьмет план из кэша.
  if (getPlannerMode(state, currentPlayer.id).enabled) {
    ensureRoundPlan({
      currentPlayer,
      units,
      players: selectPlayers(state),
      citiesCache: selectCitiesCache(state),
      hexes: selectHexes(state),
      gridRenderer: getBotGridRenderer(state),
      round,
      state,
    }, Boolean(store.__isBotSandbox));
  }

  // Волна 37 (T, гейт isPreW37ThreatHirePlayer): угроза захвата города В ЭТОМ
  // раунде — раньше прочего найма. Сначала размер заслону на казарме такого
  // города (нанятому прошлым тиком или своему отряду), пока он не переживет
  // ожидаемый урон, затем заслон на казарме города без держателя (сверх потолка
  // армии и без накоплений). У legacy T — пропуск
  if (w37 && w37.isThreatHire) {
    const weakGuardIds = w37.getWeakGuardIds();
    if (weakGuardIds.size > 0 && trySizeRecruitment(store, state, currentPlayer, playerUnits, {
      unitFilter: weakGuardIds, w35, w37, w37ForceUnitIds: weakGuardIds,
    })) {
      if (Array.isArray(globalThis.__w37HireLog)) {
        const sizeAction = (selectPendingRecruitmentActions(store.getState()) || []).slice(-1)[0];
        recordW37Hire(store, {
          kind: 'threatSize', round, playerId: currentPlayer.id, factionId: currentPlayer.factionId,
          unitId: sizeAction?.unitId || null, price: sizeAction?.price || 0, sizeAdded: sizeAction?.sizeAdded || 0,
        });
      }
      return true;
    }
    if (tryW37ThreatGuardHire(store, state, currentPlayer, playerUnits, w37)) {
      return true;
    }
  }

  // Волна 35 (G-найм, держатель из накоплений): обязательные по доктрине города
  // под угрозой «скоро» и выше — раньше прочего найма. Сначала размер слабому
  // держателю такого города на казарме (и своему отряду на казарме города без
  // держателя, который пока его не удержит), затем заслон на казарме города, до
  // которого не дойдет ни один свой отряд. У legacy G (и без контекста) — пропуск
  if (w35 && w35.isGarrisonHire) {
    const threatenedWeakHolderIds = w35.getSavingsBypassHolderIds();
    if (threatenedWeakHolderIds.size > 0 && trySizeRecruitment(store, state, currentPlayer, playerUnits, {
      unitFilter: threatenedWeakHolderIds, w35,
    })) {
      if (Array.isArray(globalThis.__w35HolderHireLog)) {
        const sizeAction = (selectPendingRecruitmentActions(store.getState()) || []).slice(-1)[0];
        const sizedUnit = sizeAction ? playerUnits.find((unit) => unit.id === sizeAction.unitId) : null;
        const sizedCity = sizedUnit ? (selectCitiesCache(state)?.[currentPlayer.color] || []).find(
          (city) => (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).includes(sizedUnit.hexKey)
        ) : null;
        recordW35HolderHire(store, {
          kind: 'size', round, playerId: currentPlayer.id, factionId: currentPlayer.factionId,
          cityKey: sizedCity ? sizedCity.centralQuarter : null, unitId: sizeAction?.unitId || null,
          price: sizeAction?.price || 0, sizeAdded: sizeAction?.sizeAdded || 0, decision: 'size',
        });
      }
      return true;
    }
    if (tryW35HolderHire(store, state, currentPlayer, playerUnits, w35, w37)) {
      return true;
    }
  }

  // Гномы: экономный эндшпиль при SERVARIANISM с большим доходом — монеты
  // копятся на конвертацию, найм только при угрозе своим городам
  if (isPlayerFaction(currentPlayer, FACTIONS.DWARVES)
    && isPlayerPolicy(currentPlayer, POLICIES.SERVARIANISM)
    && (currentPlayer.coinsIncome || 0) >= 18
    && round >= FINAL_ROUND - 3
  ) {
    const isUnderThreat = findOwnCitiesUnderThreat(
      currentPlayer, units, selectCitiesCache(state), getBotGridRenderer(state)
    ).length > 0;
    if (!isUnderThreat) {
      return false;
    }
  }

  // Эльфы: доктрина крупных отрядов — сначала апгрейды (d6 -> d10 -> d20 на
  // своей казарме) и найм размера, и только потом новые отряды.
  // При армии меньше 3 отрядов порядок обратный: сперва восполняем линию —
  // элитная армия из 1-2 отрядов гибнет целиком (данные отчета 4)
  const isElves = isPlayerFaction(currentPlayer, FACTIONS.ELVES);
  if (isElves && playerUnits.length >= 3) {
    if (tryUnitUpgrade(store, state, currentPlayer, playerUnits)) {
      return true;
    }
    // Комбо PATRIOTISM + арсенал: агрессивный найм размера (оба дешевле).
    // Волна 23 (22.6): с PATRIOTISM (и без арсенала) — все монеты в докупку
    // размера отрядам на казармах, приоритет d10/d20 (сортировка по maxSize)
    const hasElfPatriotism = isPlayerPolicy(currentPlayer, POLICIES.PATRIOTISM);
    const isElfPatriotismAllIn = hasElfPatriotism;
    const hasPatriotismArsenal = hasElfPatriotism
      && checkIfHasArsenalInBarracksCity(currentPlayer, selectCitiesCache(state));
    const elfProfile = getBotProfile(state, currentPlayer);
    const isElfSizeHireOpenBeforeLateGame = isElfPatriotismAllIn || hasPatriotismArsenal
      || elfProfile.sizeHireMode === 'early';
    // Волна 35 (R): поздняя игра — от лимита партии и только под цель или угрозу
    const elfLateSizeHireIds = isW35LateHire && round >= w35.sizeHireOpenRound
      ? w35.getLateSizeUnitIds(playerUnits)
      : null;
    const isElfLateGame = isW35LateHire
      ? Boolean(elfLateSizeHireIds && elfLateSizeHireIds.size > 0)
      : round >= SIZE_HIRE_LATE_GAME_ROUND;
    if (isElfSizeHireOpenBeforeLateGame || isElfLateGame) {
      // Открыто только поздней игрой или идет окно конца партии — размер лишь отрядам под цель (R)
      const elfUnitFilter = isW35LateHire && (w35.isFinalWindow || !isElfSizeHireOpenBeforeLateGame)
        ? w35.getLateSizeUnitIds(playerUnits)
        : null;
      if (trySizeRecruitment(store, state, currentPlayer, playerUnits,
        {elfPatriotismAllIn: isElfPatriotismAllIn, unitFilter: elfUnitFilter, w35, w37}
      )) {
        return true;
      }
    }
  }

  // Лепреконы: с середины игры апгрейды d6 -> d10 -> d20 перед наймом новых —
  // кража монет масштабируется максимальной численностью отряда (живой тест 14)
  if (isPlayerFaction(currentPlayer, FACTIONS.LEPRECHAUNS) && round >= 5
    && tryUnitUpgrade(store, state, currentPlayer, playerUnits)
  ) {
    return true;
  }

  // Волна 37 (A, гейт isPreW37CampArsenalHirePlayer): свежему найму в городе с
  // рабочим арсеналом — размер сразу, в той же фазе (2 за монету), до следующего
  // найма. В окне конца партии (R) — только отрядам под цель или угрозу, как
  // всему размеру
  const w37FreshArsenalIds = w37 && w37.isCampArsenalHire ? w37.getFreshArsenalUnitIds() : null;
  if (w37FreshArsenalIds && w37FreshArsenalIds.size > 0) {
    const freshArsenalIds = intersectUnitFilters(w37FreshArsenalIds, getW35FinalWindowSizeFilter());
    if (freshArsenalIds.size > 0 && trySizeRecruitment(store, state, currentPlayer, playerUnits, {
      unitFilter: freshArsenalIds, w35, w37,
    })) {
      if (Array.isArray(globalThis.__w37HireLog)) {
        const sizeAction = (selectPendingRecruitmentActions(store.getState()) || []).slice(-1)[0];
        recordW37Hire(store, {
          kind: 'arsenalSize', round, playerId: currentPlayer.id, factionId: currentPlayer.factionId,
          unitId: sizeAction?.unitId || null, price: sizeAction?.price || 0, sizeAdded: sizeAction?.sizeAdded || 0,
        });
      }
      return true;
    }
  }

  if (tryRecruitNewUnit(store, state, currentPlayer, playerUnits, w35, w37)) {
    return true;
  }

  // Волна 32 (армия, A5, гейт isPreW32ArmyUpgradePlayer): новый отряд не нанят
  // (потолок, ферма, казармы заняты) — поднимаем лимит размера подросшему отряду.
  // У legacy короткое замыкание
  if (!isPreW32ArmyUpgradePlayer(currentPlayer.id)
    && tryW32UnitUpgrade(store, state, currentPlayer, playerUnits)
  ) {
    return true;
  }

  // Инсектоиды: пока есть свободные слоты отрядов и не поздняя игра, монеты
  // идут в НОВЫЕ отряды и казармы, а не в найм размера — масса важнее.
  // Волна 31: потолок инсектоидов поднят на INSECTOIDS_EXTRA_UNIT_SLOTS,
  // и «свободные слоты» здесь считаются по тому же поднятому потолку.
  // Волна 38 (C): база потолка — по лиге бота (getBotHireArmyCap). Слот «свободен»,
  // только если новый отряд пустят и правила: инсектоиды нанимают из предпочтений
  // (d10, d8, d6 — не больше 12 по лимиту «одного типа»), а потолок рубина 13 и
  // божества 15 — иначе при 12 отрядах размер не докупался бы до поздней игры.
  // При базе 4 (legacy, без лиги) — прежний счет
  const insectoidsBaseCap = getBotHireArmyCap(currentPlayer);
  let insectoidsSizeHireCap = insectoidsBaseCap
    + (isPreRecruitmentCapFixPlayer(currentPlayer.id) ? 0 : getInsectoidsExtraUnitSlots());
  if (insectoidsBaseCap > UNITS_SAME_TIME_COUNT_LIMIT && isPlayerFaction(currentPlayer, FACTIONS.INSECTOIDS)) {
    const freeTypeSlots = getRecruitmentTypePreference(currentPlayer, round, playerUnits, selectCitiesCache(state))
      .reduce((sum, unitTypeId) => sum + Math.max(0, getSameTypeUnitLimit(currentPlayer, unitTypeId)
        - playerUnits.filter((unit) => unit.type === unitTypeId).length), 0);
    insectoidsSizeHireCap = Math.min(insectoidsSizeHireCap, playerUnits.length + freeTypeSlots);
  }
  // Волна 35 (R): поздняя игра — от лимита партии (configs/botLateHire), а не с 10 раунда
  const lateSizeHireRound = isW35LateHire ? w35.sizeHireOpenRound : SIZE_HIRE_LATE_GAME_ROUND;
  if (isPlayerFaction(currentPlayer, FACTIONS.INSECTOIDS)
    && playerUnits.length < insectoidsSizeHireCap
    && round < lateSizeHireRound
  ) {
    return false;
  }

  // Волна 35: найм размера только этим отрядам (null — любым на казармах, как прежде)
  let sizeUnitFilter = null;
  // Нюанс #6: найм размера за монеты фактически дорог. Разрешаем его рано только
  // раш-архетипу; остальным — при обороне своих городов, в поздней игре
  // или при профиците монет (есть с кем сражаться — мертвый запас идет в размер).
  const profile = getBotProfile(state, currentPlayer);
  if (profile.sizeHireMode !== 'early') {
    const isLateGame = round >= lateSizeHireRound;
    const hasOpponentsOnMap = units.some((unit) => unit.ownerId !== currentPlayer.id);
    const hasCoinSurplus = currentPlayer.coins >= BOT_COIN_SURPLUS_THRESHOLD
      && !isPlayerFaction(currentPlayer, FACTIONS.ENLIGHTENED)
      && hasOpponentsOnMap;
    if (!isLateGame && !hasCoinSurplus) {
      const citiesCache = selectCitiesCache(state);
      const gridRenderer = getBotGridRenderer(state);
      const isUnderThreat = findOwnCitiesUnderThreat(currentPlayer, units, citiesCache, gridRenderer).length > 0;
      if (!isUnderThreat && !hasW32GuardNeed()) {
        // Волна 35 (G-найм): слабому держателю гарнизона открытого города размер
        // докупается и без угрозы — но только ему, не всей армии (волна 32
        // «больше трат на армию» стоила −0.63 очка)
        const weakHolderIds = getW35WeakHolderIds();
        if (weakHolderIds.size === 0) {
          return false;
        }
        sizeUnitFilter = weakHolderIds;
      }
    } else if (isLateGame && !hasCoinSurplus && isW35LateHire) {
      // Волна 35 (R): номер раунда сам по себе размер больше не открывает — нужна
      // угроза своим городам или отряд на казарме, которому есть кого ударить
      // или что защитить до конца партии (у прежнего правила с 10 раунда в R12
      // 43% монет размера уходили без эффекта)
      const isUnderThreat = findOwnCitiesUnderThreat(
        currentPlayer, units, selectCitiesCache(state), getBotGridRenderer(state)
      ).length > 0;
      if (!isUnderThreat && !hasW32GuardNeed()) {
        const lateSizeHireIds = new Set([...w35.getLateSizeUnitIds(playerUnits), ...getW35WeakHolderIds()]);
        if (lateSizeHireIds.size === 0) {
          return false;
        }
        sizeUnitFilter = lateSizeHireIds;
      }
    }
  }

  // Живой тест 16.7: зверолюды на ранних этапах не докупают размер — монеты
  // идут в новые отряды и экономику (исключение — оборона своих городов)
  if (isPlayerFaction(currentPlayer, FACTIONS.BEASTMEN)
    && round <= 5
  ) {
    const isUnderThreat = findOwnCitiesUnderThreat(
      currentPlayer, units, selectCitiesCache(state), getBotGridRenderer(state)
    ).length > 0;
    if (!isUnderThreat && !hasW32GuardNeed()) {
      // Волна 35 (G-найм): как и выше — только слабым держателям гарнизонов
      const weakHolderIds = getW35WeakHolderIds();
      if (weakHolderIds.size === 0) {
        return false;
      }
      sizeUnitFilter = intersectUnitFilters(sizeUnitFilter, weakHolderIds);
    }
  }

  // У legacy оба фильтра и контексты — null: прежний вызов дословно
  return trySizeRecruitment(store, state, currentPlayer, playerUnits, {
    unitFilter: intersectUnitFilters(sizeUnitFilter, getW35FinalWindowSizeFilter()),
    w35,
    w37,
  });
};
